import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Upload: any;
};

export type AbapInput = {
  applicationComponent: Scalars['String'];
  collectionOwner?: InputMaybe<Scalars['String']>;
  collectionPackage: Scalars['String'];
  deadline: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  issueType: IssueType;
  languagesTranslatorTeams?: InputMaybe<Scalars['String']>;
  maxLength?: InputMaybe<Scalars['Float']>;
  objectName: Scalars['String'];
  objectOwner?: InputMaybe<Scalars['String']>;
  objectType: Scalars['String'];
  pmName?: InputMaybe<Scalars['String']>;
  project: Scalars['Int'];
  repositoryProgramId: Scalars['String'];
  repositoryProgramName: Scalars['String'];
  repositoryProgramType: Scalars['String'];
  sourceText: Scalars['String'];
  system: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  translationArea: Scalars['String'];
};

export type AbapInputUpdate = {
  applicationComponent: Scalars['String'];
  assignee?: InputMaybe<Scalars['String']>;
  collectionOwner?: InputMaybe<Scalars['String']>;
  collectionPackage: Scalars['String'];
  deadline?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  /** Project Language IDs that will be used to distribute the query to. */
  distributions?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['Float'];
  issueType: IssueType;
  maxLength?: InputMaybe<Scalars['Float']>;
  objectName: Scalars['String'];
  objectOwner?: InputMaybe<Scalars['String']>;
  objectType: Scalars['String'];
  qeReview: Scalars['Boolean'];
  repositoryProgramId: Scalars['String'];
  repositoryProgramName: Scalars['String'];
  repositoryProgramType: Scalars['String'];
  /** Distributions IDs that will be used to reset the distributions. */
  resetedDistributions?: InputMaybe<Array<Scalars['String']>>;
  sourceText: Scalars['String'];
  system: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  translationArea: Scalars['String'];
};

export type AbapQuery = {
  __typename?: 'AbapQuery';
  applicationComponent: Scalars['String'];
  baseQuery: BaseQuery;
  collectionOwner?: Maybe<Scalars['String']>;
  collectionPackage: Scalars['String'];
  id: Scalars['ID'];
  languagesTranslatorTeams?: Maybe<Scalars['String']>;
  maxLength?: Maybe<Scalars['Float']>;
  objectName: Scalars['String'];
  objectOwner?: Maybe<Scalars['String']>;
  objectType: Scalars['String'];
  repositoryProgramId: Scalars['String'];
  repositoryProgramName: Scalars['String'];
  repositoryProgramType: Scalars['String'];
  system: Scalars['String'];
  translationArea: Scalars['String'];
};

export type Attachment = {
  __typename?: 'Attachment';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  path: Scalars['String'];
  uploadedBy: User;
};

export type AttachmentResponse = {
  __typename?: 'AttachmentResponse';
  attachment?: Maybe<Attachment>;
};

export type AttachmentSignedUrlResponse = {
  __typename?: 'AttachmentSignedUrlResponse';
  url: Scalars['String'];
};

export type BaseQuery = {
  __typename?: 'BaseQuery';
  assignedTo?: Maybe<User>;
  assignee?: Maybe<Scalars['String']>;
  attachments: Array<Attachment>;
  comments: Array<QueryComment>;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  deadline: Scalars['String'];
  details?: Maybe<Scalars['String']>;
  distributions: Array<Distribution>;
  forwardReviewTo?: Maybe<ForwardReview>;
  id: Scalars['ID'];
  issueType: IssueType;
  languagesByQueryCreator: Array<Maybe<ProjectLanguage>>;
  pmName?: Maybe<Scalars['String']>;
  project: Project;
  qeReview: Scalars['Boolean'];
  qtId?: Maybe<Scalars['Float']>;
  queryDetails?: Maybe<QueryDetails>;
  sourceText?: Maybe<Scalars['String']>;
  status: Status;
  submitterGroupName?: Maybe<Scalars['String']>;
  targetLanguage: Scalars['String'];
  targetText?: Maybe<Scalars['String']>;
  translationType: TranslationType;
  updatedAt: Scalars['DateTime'];
};

export type BaseQueryAssigneeInputUpdate = {
  abapQueries?: InputMaybe<Array<AbapInputUpdate>>;
  corporateContentQueries?: InputMaybe<Array<CorporateContentInputUpdate>>;
  ditaQueries?: InputMaybe<Array<DitaInputUpdate>>;
  ids: Array<Scalars['Int']>;
  marketingQueries?: InputMaybe<Array<MarketingInputUpdate>>;
  nonAbapQueries?: InputMaybe<Array<NonAbapInputUpdate>>;
  notesQueries?: InputMaybe<Array<NotesInputUpdate>>;
  trainingQueries?: InputMaybe<Array<TrainingInputUpdate>>;
};

export type BaseQueryFilters = {
  account?: InputMaybe<Scalars['String']>;
  answerer?: InputMaybe<Scalars['String']>;
  applicationComponent?: InputMaybe<Scalars['String']>;
  assignee?: InputMaybe<Scalars['String']>;
  collection?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Array<Scalars['DateTime']>>;
  createdBy?: InputMaybe<Scalars['String']>;
  distributed?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Scalars['String']>;
  implementationLanguage?: InputMaybe<Array<Scalars['String']>>;
  implementationStatus?: InputMaybe<Array<DistributionStatus>>;
  issueType?: InputMaybe<Array<IssueType>>;
  loio?: InputMaybe<Scalars['String']>;
  objectName?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Scalars['String']>;
  projectManager?: InputMaybe<Scalars['String']>;
  qualityExpert?: InputMaybe<Scalars['String']>;
  queryResponsible?: InputMaybe<Scalars['String']>;
  queryTrackerId?: InputMaybe<Scalars['String']>;
  repository?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sourceContact?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Status>>;
  stringId?: InputMaybe<Scalars['String']>;
  submitterGroupName?: InputMaybe<Scalars['String']>;
  substitutePm?: InputMaybe<Scalars['String']>;
  targetLanguage?: InputMaybe<Scalars['String']>;
  translationArea?: InputMaybe<Scalars['String']>;
  translationType?: InputMaybe<TranslationType>;
  xtmProjectName?: InputMaybe<Scalars['String']>;
};

export type BaseQueryPage = {
  __typename?: 'BaseQueryPage';
  edges?: Maybe<Array<Edge>>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type ClarifyQueryInput = {
  commentText: Scalars['String'];
  queryId: Scalars['Int'];
};

export type ColumnConfig = {
  __typename?: 'ColumnConfig';
  account?: Maybe<Scalars['Boolean']>;
  applicationComponent?: Maybe<Scalars['Boolean']>;
  assignee?: Maybe<Scalars['Boolean']>;
  collection?: Maybe<Scalars['Boolean']>;
  creator?: Maybe<Scalars['Boolean']>;
  deadline?: Maybe<Scalars['Boolean']>;
  filename?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Boolean']>;
  issue?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['Boolean']>;
  loio?: Maybe<Scalars['Boolean']>;
  projectManager?: Maybe<Scalars['Boolean']>;
  projectName?: Maybe<Scalars['Boolean']>;
  qmContact?: Maybe<Scalars['Boolean']>;
  qualityExpert?: Maybe<Scalars['Boolean']>;
  queryCreatedAt?: Maybe<Scalars['Boolean']>;
  queryTrackerId?: Maybe<Scalars['Boolean']>;
  repository?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['Boolean']>;
  sourceContact?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Boolean']>;
  stringId?: Maybe<Scalars['Boolean']>;
  submitterGroupName?: Maybe<Scalars['Boolean']>;
  substitutePm?: Maybe<Scalars['Boolean']>;
  translation?: Maybe<Scalars['Boolean']>;
  xtmProjectName?: Maybe<Scalars['Boolean']>;
};

export type ColumnConfigInput = {
  account?: InputMaybe<Scalars['Boolean']>;
  applicationComponent?: InputMaybe<Scalars['Boolean']>;
  assignee?: InputMaybe<Scalars['Boolean']>;
  collection?: InputMaybe<Scalars['Boolean']>;
  creator?: InputMaybe<Scalars['Boolean']>;
  deadline?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  issue?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['Boolean']>;
  loio?: InputMaybe<Scalars['Boolean']>;
  projectManager?: InputMaybe<Scalars['Boolean']>;
  projectName?: InputMaybe<Scalars['Boolean']>;
  qmContact?: InputMaybe<Scalars['Boolean']>;
  qualityExpert?: InputMaybe<Scalars['Boolean']>;
  queryCreatedAt?: InputMaybe<Scalars['Boolean']>;
  queryTrackerId?: InputMaybe<Scalars['Boolean']>;
  repository?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['Boolean']>;
  sourceContact?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['Boolean']>;
  stringId?: InputMaybe<Scalars['Boolean']>;
  submitterGroupName?: InputMaybe<Scalars['Boolean']>;
  substitutePm?: InputMaybe<Scalars['Boolean']>;
  translation?: InputMaybe<Scalars['Boolean']>;
  xtmProjectName?: InputMaybe<Scalars['Boolean']>;
};

export enum CommentType {
  ANSWER = 'ANSWER',
  CLARIFIED = 'CLARIFIED',
  COMMENT = 'COMMENT',
  HISTORY = 'HISTORY',
  REQUEST_CLARIFICATION = 'REQUEST_CLARIFICATION'
}

export type CompleteDistributionInput = {
  distributionId: Scalars['Int'];
  status: DistributionStatus;
};

export type CorporateContentInput = {
  deadline: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  issueType: IssueType;
  pmName?: InputMaybe<Scalars['String']>;
  project: Scalars['Int'];
  sourceText: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  xtmProjectName?: InputMaybe<Scalars['String']>;
};

export type CorporateContentInputUpdate = {
  assignee?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  /** Project Language IDs that will be used to distribute the query to. */
  distributions?: InputMaybe<Array<Scalars['String']>>;
  fileName: Scalars['String'];
  id: Scalars['Float'];
  issueType: IssueType;
  qeReview: Scalars['Boolean'];
  /** Distributions IDs that will be used to reset the distributions. */
  resetedDistributions?: InputMaybe<Array<Scalars['String']>>;
  sourceText: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  xtmProjectName?: InputMaybe<Scalars['String']>;
};

export type CorporateContentQuery = {
  __typename?: 'CorporateContentQuery';
  baseQuery: BaseQuery;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  xtmProjectName?: Maybe<Scalars['String']>;
};

export type Distribution = {
  __typename?: 'Distribution';
  distribute: Scalars['Boolean'];
  id: Scalars['ID'];
  language: ProjectLanguage;
  languageCode?: Maybe<Scalars['String']>;
  query?: Maybe<BaseQuery>;
  status: DistributionStatus;
  updatedAt: Scalars['DateTime'];
};

export enum DistributionStatus {
  CHANGE_MADE = 'CHANGE_MADE',
  CHANGE_NOT_NEEDED = 'CHANGE_NOT_NEEDED',
  DRAFT = 'DRAFT',
  NOT_RELEVANT_TO_LANGUAGE = 'NOT_RELEVANT_TO_LANGUAGE',
  OTHER = 'OTHER',
  PENDING = 'PENDING',
  SOURCE_ALREADY_CORRECTED = 'SOURCE_ALREADY_CORRECTED',
  SOURCE_NOT_FOUND = 'SOURCE_NOT_FOUND'
}

export type DitaInput = {
  cmsProject: Scalars['String'];
  deadline: Scalars['String'];
  deliverable: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileTitle: Scalars['String'];
  issueType: IssueType;
  languagesTranslatorTeams?: InputMaybe<Scalars['String']>;
  loio: Scalars['String'];
  pmName?: InputMaybe<Scalars['String']>;
  project: Scalars['Int'];
  sourceContact: Scalars['String'];
  sourceText: Scalars['String'];
  submap?: InputMaybe<Scalars['String']>;
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  xtmProjectName?: InputMaybe<Scalars['String']>;
};

export type DitaInputUpdate = {
  assignee?: InputMaybe<Scalars['String']>;
  cmsProject: Scalars['String'];
  deadline?: InputMaybe<Scalars['String']>;
  deliverable: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  /** Project Language IDs that will be used to distribute the query to. */
  distributions?: InputMaybe<Array<Scalars['String']>>;
  fileName: Scalars['String'];
  fileTitle: Scalars['String'];
  id: Scalars['Float'];
  issueType: IssueType;
  loio: Scalars['String'];
  qeReview: Scalars['Boolean'];
  /** Distributions IDs that will be used to reset the distributions. */
  resetedDistributions?: InputMaybe<Array<Scalars['String']>>;
  sourceContact: Scalars['String'];
  sourceText: Scalars['String'];
  submap?: InputMaybe<Scalars['String']>;
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  xtmProjectName?: InputMaybe<Scalars['String']>;
};

export type DitaQuery = {
  __typename?: 'DitaQuery';
  baseQuery: BaseQuery;
  cmsProject: Scalars['String'];
  deliverable: Scalars['String'];
  fileName: Scalars['String'];
  fileTitle: Scalars['String'];
  id: Scalars['ID'];
  languagesTranslatorTeams?: Maybe<Scalars['String']>;
  loio: Scalars['String'];
  sourceContact: Scalars['String'];
  sourceContactDisplayName: Scalars['String'];
  submap?: Maybe<Scalars['String']>;
  xtmProjectName?: Maybe<Scalars['String']>;
};

export enum DocumentType {
  KBA = 'KBA',
  SAP_NOTE = 'SAP_NOTE'
}

export type Edge = {
  __typename?: 'Edge';
  cursor?: Maybe<Scalars['String']>;
  node: BaseQuery;
};

export type EmailInput = {
  body: Scalars['String'];
  subject: Scalars['String'];
  to: Scalars['String'];
};

export enum ForwardReview {
  ANSWERER = 'ANSWERER',
  CREATOR = 'CREATOR'
}

export enum IssueType {
  SOURCE_ERROR = 'SOURCE_ERROR',
  SOURCE_EXPLAIN_MEANING = 'SOURCE_EXPLAIN_MEANING',
  SOURCE_INCORRECT_ORIGINAL_LANGUAGE = 'SOURCE_INCORRECT_ORIGINAL_LANGUAGE',
  SOURCE_IS_VERB_NOUN_ADJECTIVE = 'SOURCE_IS_VERB_NOUN_ADJECTIVE',
  SOURCE_MIXED_LANGUAGE = 'SOURCE_MIXED_LANGUAGE',
  SOURCE_NOT_FOUND = 'SOURCE_NOT_FOUND',
  SOURCE_NO_ENOUGH_SPACE_TRANSLATION = 'SOURCE_NO_ENOUGH_SPACE_TRANSLATION',
  SOURCE_OTHER_ISSUE = 'SOURCE_OTHER_ISSUE',
  SOURCE_SAPTERM_OTHER_ISSUE = 'SOURCE_SAPTERM_OTHER_ISSUE',
  SOURCE_SAPTERM_TERM_NOT_ENTERED_OR_RELEASED = 'SOURCE_SAPTERM_TERM_NOT_ENTERED_OR_RELEASED',
  SOURCE_SHOULD_TEXT_BE_TRANSLATED = 'SOURCE_SHOULD_TEXT_BE_TRANSLATED',
  SOURCE_TEXT_NOT_CREATED_IN_DEVELOPMENT_LANGUAGE = 'SOURCE_TEXT_NOT_CREATED_IN_DEVELOPMENT_LANGUAGE',
  SOURCE_TRANSLATION_RELEVANT = 'SOURCE_TRANSLATION_RELEVANT',
  SOURCE_WHAT_PLACEHOLDER_STAND = 'SOURCE_WHAT_PLACEHOLDER_STAND',
  SOURCE_WHAT_TERM_REFER = 'SOURCE_WHAT_TERM_REFER',
  TARGET_INCONSISTENT_TRANSLATION = 'TARGET_INCONSISTENT_TRANSLATION',
  TARGET_OTHER_ISSUE = 'TARGET_OTHER_ISSUE',
  TARGET_SAPTERM_ISSUE = 'TARGET_SAPTERM_ISSUE'
}

export type MarketingInput = {
  deadline: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  issueType: IssueType;
  pmName?: InputMaybe<Scalars['String']>;
  project: Scalars['Int'];
  sourceText: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
};

export type MarketingInputUpdate = {
  assignee?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  /** Project Language IDs that will be used to distribute the query to. */
  distributions?: InputMaybe<Array<Scalars['String']>>;
  fileName?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  issueType: IssueType;
  qeReview: Scalars['Boolean'];
  /** Distributions IDs that will be used to reset the distributions. */
  resetedDistributions?: InputMaybe<Array<Scalars['String']>>;
  sourceText: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
};

export type MarketingQuery = {
  __typename?: 'MarketingQuery';
  account?: Maybe<Scalars['String']>;
  baseQuery: BaseQuery;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type MsGraphUser = {
  __typename?: 'MsGraphUser';
  businessPhones?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  officeLocation?: Maybe<Scalars['String']>;
  preferredLanguage?: Maybe<Scalars['String']>;
  sapName?: Maybe<Scalars['String']>;
  sapNumber?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  userPrincipalName?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCommentToQuery: QueryComment;
  bulkUpdateSearchFilters: Array<SearchFilter>;
  bulkUpdateSearchFiltersSubscriptions: Array<SearchFilter>;
  clarifyQuery: BaseQuery;
  completeAnsweredQuery: BaseQuery;
  completeDistribution: Distribution;
  createAbapQuery: AbapQuery;
  createCorporateContentQuery: CorporateContentQuery;
  createDitaQuery: DitaQuery;
  createMarketingQuery: MarketingQuery;
  createNonAbapQuery: NonAbapQuery;
  createNotesQuery: NotesQuery;
  createSearchFilter: SearchFilter;
  createTrainingQuery: TrainingQuery;
  deleteFile: Scalars['Boolean'];
  deleteQueryById: Scalars['Boolean'];
  deleteSearchFilter: Scalars['Boolean'];
  discontinueQueryById: BaseQuery;
  distributeQuery: BaseQuery;
  forwardToAnswerer: BaseQuery;
  forwardToCreator: BaseQuery;
  importAbapQueries: Array<QtImport>;
  importFile: QtImport;
  provideAnswer: BaseQuery;
  requestClarification: BaseQuery;
  sendEmail: Scalars['Boolean'];
  updateAbapQuery: AbapQuery;
  updateAssignee: Array<BaseQuery>;
  updateCorporateContentQuery: CorporateContentQuery;
  updateDitaQuery: DitaQuery;
  updateMarketingQuery: MarketingQuery;
  updateNonAbapQuery: NonAbapQuery;
  updateNotesQuery: NotesQuery;
  updateSearchFilter: SearchFilter;
  updateTrainingQuery: TrainingQuery;
  updateUserSupplier?: Maybe<User>;
  uploadFile: AttachmentResponse;
};

export type MutationAddCommentToQueryArgs = {
  input: QueryCommentInput;
};

export type MutationBulkUpdateSearchFiltersArgs = {
  searchFiltersDeleted: Array<SearchFilterDelete>;
  searchFiltersUpdated: Array<SearchFilterUpdate>;
};

export type MutationBulkUpdateSearchFiltersSubscriptionsArgs = {
  searchFilters: Array<SearchFilterSubscribe>;
};

export type MutationClarifyQueryArgs = {
  input: ClarifyQueryInput;
};

export type MutationCompleteAnsweredQueryArgs = {
  id: Scalars['ID'];
};

export type MutationCompleteDistributionArgs = {
  input: CompleteDistributionInput;
};

export type MutationCreateAbapQueryArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  input: AbapInput;
};

export type MutationCreateCorporateContentQueryArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  input: CorporateContentInput;
};

export type MutationCreateDitaQueryArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  input: DitaInput;
};

export type MutationCreateMarketingQueryArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  input: MarketingInput;
};

export type MutationCreateNonAbapQueryArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  input: NonAbapInput;
};

export type MutationCreateNotesQueryArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  input: NotesInput;
};

export type MutationCreateSearchFilterArgs = {
  searchFilter: SearchFilterCreate;
};

export type MutationCreateTrainingQueryArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  input: TrainingInput;
};

export type MutationDeleteFileArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteQueryByIdArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteSearchFilterArgs = {
  id: Scalars['String'];
};

export type MutationDiscontinueQueryByIdArgs = {
  id: Scalars['ID'];
};

export type MutationDistributeQueryArgs = {
  id: Scalars['ID'];
};

export type MutationForwardToAnswererArgs = {
  id: Scalars['ID'];
};

export type MutationForwardToCreatorArgs = {
  id: Scalars['ID'];
};

export type MutationImportAbapQueriesArgs = {
  endDate: Scalars['String'];
  projects: Array<Scalars['String']>;
  startDate: Scalars['String'];
};

export type MutationImportFileArgs = {
  file: Scalars['Upload'];
};

export type MutationProvideAnswerArgs = {
  input: QueryAnswerInput;
};

export type MutationRequestClarificationArgs = {
  input: RequestClarificationInput;
};

export type MutationSendEmailArgs = {
  email: EmailInput;
};

export type MutationUpdateAbapQueryArgs = {
  input: AbapInputUpdate;
};

export type MutationUpdateAssigneeArgs = {
  input: BaseQueryAssigneeInputUpdate;
};

export type MutationUpdateCorporateContentQueryArgs = {
  input: CorporateContentInputUpdate;
};

export type MutationUpdateDitaQueryArgs = {
  input: DitaInputUpdate;
};

export type MutationUpdateMarketingQueryArgs = {
  input: MarketingInputUpdate;
};

export type MutationUpdateNonAbapQueryArgs = {
  input: NonAbapInputUpdate;
};

export type MutationUpdateNotesQueryArgs = {
  input: NotesInputUpdate;
};

export type MutationUpdateSearchFilterArgs = {
  searchFilter: SearchFilterUpdate;
};

export type MutationUpdateTrainingQueryArgs = {
  input: TrainingInputUpdate;
};

export type MutationUpdateUserSupplierArgs = {
  input: Array<SupplierInput>;
  internal: Scalars['Boolean'];
};

export type MutationUploadFileArgs = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
};

export type NonAbapInput = {
  collection: Scalars['String'];
  deadline: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  issueType: IssueType;
  languagesTranslatorTeams?: InputMaybe<Scalars['String']>;
  pmName?: InputMaybe<Scalars['String']>;
  project: Scalars['Int'];
  repository: Scalars['String'];
  sourceContact: Scalars['String'];
  sourceText: Scalars['String'];
  stringId: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  xtmProjectName: Scalars['String'];
};

export type NonAbapInputUpdate = {
  assignee?: InputMaybe<Scalars['String']>;
  collection: Scalars['String'];
  deadline?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  /** Project Language IDs that will be used to distribute the query to. */
  distributions?: InputMaybe<Array<Scalars['String']>>;
  fileName: Scalars['String'];
  id: Scalars['Float'];
  issueType: IssueType;
  qeReview: Scalars['Boolean'];
  repository: Scalars['String'];
  /** Distributions IDs that will be used to reset the distributions. */
  resetedDistributions?: InputMaybe<Array<Scalars['String']>>;
  sourceContact: Scalars['String'];
  sourceText: Scalars['String'];
  stringId: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  xtmProjectName: Scalars['String'];
};

export type NonAbapQuery = {
  __typename?: 'NonAbapQuery';
  baseQuery: BaseQuery;
  collection: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['ID'];
  languagesTranslatorTeams?: Maybe<Scalars['String']>;
  repository: Scalars['String'];
  sourceContact: Scalars['String'];
  sourceContactDisplayName: Scalars['String'];
  stringId: Scalars['String'];
  xtmProjectName: Scalars['String'];
};

export type NotesInput = {
  component: Scalars['String'];
  deadline: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  documentNumber: Scalars['String'];
  documentResponsible?: InputMaybe<Scalars['String']>;
  documentType: DocumentType;
  issueType: IssueType;
  pmName?: InputMaybe<Scalars['String']>;
  project: Scalars['Int'];
  sourceText: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  worklist?: InputMaybe<Worklist>;
};

export type NotesInputUpdate = {
  assignee?: InputMaybe<Scalars['String']>;
  component: Scalars['String'];
  deadline?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  /** Project Language IDs that will be used to distribute the query to. */
  distributions?: InputMaybe<Array<Scalars['String']>>;
  documentNumber: Scalars['String'];
  documentResponsible?: InputMaybe<Scalars['String']>;
  documentType: DocumentType;
  id: Scalars['Float'];
  issueType: IssueType;
  qeReview: Scalars['Boolean'];
  /** Distributions IDs that will be used to reset the distributions. */
  resetedDistributions?: InputMaybe<Array<Scalars['String']>>;
  sourceText: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  worklist?: InputMaybe<Worklist>;
};

export type NotesQuery = {
  __typename?: 'NotesQuery';
  baseQuery: BaseQuery;
  component: Scalars['String'];
  documentNumber: Scalars['String'];
  documentResponsible?: Maybe<Scalars['String']>;
  documentResponsibleDisplayName?: Maybe<Scalars['String']>;
  documentType: DocumentType;
  id: Scalars['ID'];
  worklist?: Maybe<Worklist>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

export type Project = {
  __typename?: 'Project';
  /** Deadline used for all translations except english */
  deadline?: Maybe<Scalars['String']>;
  /** Deadline used for english translations */
  englishDeadline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSolProject: Scalars['Boolean'];
  languages: Array<Maybe<ProjectLanguage>>;
  name: Scalars['String'];
  programId?: Maybe<Scalars['String']>;
  programName: Scalars['String'];
  projectId: Scalars['String'];
  projectManager?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  qualityExpert?: Maybe<Scalars['String']>;
  queryResponsible?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  stakeholders?: Maybe<Array<ProjectStakeholder>>;
  subprojectStatus?: Maybe<Scalars['String']>;
  subprojectType?: Maybe<Scalars['String']>;
  translationSystem: Scalars['String'];
  workgroup?: Maybe<Scalars['String']>;
  workgroupId?: Maybe<Scalars['String']>;
};

export type ProjectLanguage = {
  __typename?: 'ProjectLanguage';
  contentId?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  language: Scalars['String'];
  sourceLanguage?: Maybe<Scalars['String']>;
  supplier: Scalars['String'];
};

export type ProjectStakeholder = {
  __typename?: 'ProjectStakeholder';
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  stakeholderRole: StakeholderRole;
  userName: Scalars['String'];
};

export type QtImport = {
  __typename?: 'QTImport';
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  status: QtImportStatus;
  updatedAt: Scalars['DateTime'];
  user: User;
};

export enum QtImportStatus {
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export type QtProjectImport = {
  __typename?: 'QTProjectImport';
  numberOfQueries: Scalars['Float'];
  projectName: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  findAllProjects: Array<Project>;
  findAllQTImports: Array<QtImport>;
  findBaseQueriesPage: BaseQueryPage;
  findBaseQueryById?: Maybe<BaseQuery>;
  findProjectById?: Maybe<Project>;
  findProjectsByTranslationType: Array<Project>;
  findQTProjectImport: Array<QtProjectImport>;
  findSearchFilters: Array<SearchFilter>;
  getAttachmentUrl: AttachmentSignedUrlResponse;
  getMsGraphUser?: Maybe<MsGraphUser>;
  getMsGraphUsersSearchByQuery?: Maybe<Array<MsGraphUser>>;
  getUserInfo?: Maybe<User>;
};

export type QueryFindBaseQueriesPageArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<BaseQueryFilters>;
  limit: Scalars['Int'];
};

export type QueryFindBaseQueryByIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindProjectByIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindProjectsByTranslationTypeArgs = {
  translationType: TranslationType;
};

export type QueryFindQtProjectImportArgs = {
  endDate: Scalars['String'];
  projectType?: InputMaybe<Scalars['String']>;
  searchTerm: Scalars['String'];
  startDate: Scalars['String'];
};

export type QueryGetAttachmentUrlArgs = {
  id: Scalars['ID'];
};

export type QueryGetMsGraphUsersSearchByQueryArgs = {
  query: Scalars['String'];
};

export type QueryAnswerInput = {
  commentText: Scalars['String'];
  queryId: Scalars['Int'];
};

export type QueryComment = {
  __typename?: 'QueryComment';
  commentText: Scalars['String'];
  commentType: CommentType;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  query: BaseQuery;
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type QueryCommentInput = {
  commentText: Scalars['String'];
  queryId: Scalars['Int'];
};

export type QueryDetails =
  | AbapQuery
  | CorporateContentQuery
  | DitaQuery
  | MarketingQuery
  | NonAbapQuery
  | NotesQuery
  | TrainingQuery;

export type RequestClarificationInput = {
  commentText: Scalars['String'];
  queryId: Scalars['Int'];
};

export enum ResourceAccessLevel {
  INTERNAL = 'INTERNAL',
  OTHER_AGENCY = 'OTHER_AGENCY',
  SAME_AGENCY = 'SAME_AGENCY',
  SAP_ONLY = 'SAP_ONLY'
}

export type SearchFilter = {
  __typename?: 'SearchFilter';
  columnConfig?: Maybe<ColumnConfig>;
  createdAt: Scalars['DateTime'];
  favorite: Scalars['Boolean'];
  filters: Array<SearchFilterField>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  isSubscribed: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type SearchFilterCreate = {
  columnConfig: ColumnConfigInput;
  favorite?: Scalars['Boolean'];
  filters: Array<SearchFilterFieldCreate>;
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type SearchFilterDelete = {
  id: Scalars['String'];
};

export type SearchFilterField = {
  __typename?: 'SearchFilterField';
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type SearchFilterFieldCreate = {
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type SearchFilterSubscribe = {
  id: Scalars['String'];
  isSubscribed: Scalars['Boolean'];
};

export type SearchFilterUpdate = {
  columnConfig: ColumnConfigInput;
  favorite?: Scalars['Boolean'];
  filters: Array<SearchFilterFieldCreate>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  isSubscribed: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum StakeholderRole {
  BUDGET_APPROVER = 'BUDGET_APPROVER',
  BUDGET_OWNER = 'BUDGET_OWNER',
  BUSINESS_REVIEWER = 'BUSINESS_REVIEWER',
  CO_REQUESTER = 'CO_REQUESTER',
  CO_SERVICE_OWNER = 'CO_SERVICE_OWNER',
  DELIVERY_MANAGER = 'DELIVERY_MANAGER',
  DE_EN_COORDINATOR = 'DE_EN_COORDINATOR',
  LANGUAGE_TECHNOLOGY = 'LANGUAGE_TECHNOLOGY',
  LANGUAGE_TEST_COORDINATOR = 'LANGUAGE_TEST_COORDINATOR',
  LOCALIZATION_ENGINEER = 'LOCALIZATION_ENGINEER',
  PROJECT_MANAGER = 'PROJECT_MANAGER',
  QUALITY_EXPERT = 'QUALITY_EXPERT',
  QUERY_TRACKER_CONTACT = 'QUERY_TRACKER_CONTACT',
  REQUESTER = 'REQUESTER',
  RESOURCE_MANAGER = 'RESOURCE_MANAGER',
  REVIEWER = 'REVIEWER',
  SERVICE_OWNER = 'SERVICE_OWNER',
  STUDIO_SAP = 'STUDIO_SAP',
  SUBSTITUTE_DELIVERY_MANAGER = 'SUBSTITUTE_DELIVERY_MANAGER',
  SUBSTITUTE_PROJECT_MANAGER = 'SUBSTITUTE_PROJECT_MANAGER',
  TESTER = 'TESTER',
  TEST_COORDINATOR = 'TEST_COORDINATOR'
}

export enum Status {
  ANSWERED = 'ANSWERED',
  ANSWERER_TO_CLARIFY = 'ANSWERER_TO_CLARIFY',
  ASSIGNED = 'ASSIGNED',
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  CREATOR_TO_CLARIFY = 'CREATOR_TO_CLARIFY',
  DISTRIBUTED = 'DISTRIBUTED',
  NEW = 'NEW',
  PENDING_REVIEW = 'PENDING_REVIEW'
}

export type Supplier = {
  __typename?: 'Supplier';
  id: Scalars['ID'];
  name: Scalars['String'];
  vendor: Scalars['String'];
};

export type SupplierInput = {
  name: Scalars['String'];
  vendor: Scalars['String'];
};

export type TrainingInput = {
  deadline: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  issueType: IssueType;
  pmName?: InputMaybe<Scalars['String']>;
  project: Scalars['Int'];
  sourceText: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  xtmProjectName: Scalars['String'];
};

export type TrainingInputUpdate = {
  assignee?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  /** Project Language IDs that will be used to distribute the query to. */
  distributions?: InputMaybe<Array<Scalars['String']>>;
  fileName: Scalars['String'];
  id: Scalars['Float'];
  issueType: IssueType;
  qeReview: Scalars['Boolean'];
  /** Distributions IDs that will be used to reset the distributions. */
  resetedDistributions?: InputMaybe<Array<Scalars['String']>>;
  sourceText: Scalars['String'];
  targetLanguage: Scalars['String'];
  targetText?: InputMaybe<Scalars['String']>;
  xtmProjectName: Scalars['String'];
};

export type TrainingQuery = {
  __typename?: 'TrainingQuery';
  baseQuery: BaseQuery;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  xtmProjectName: Scalars['String'];
};

export enum TranslationType {
  ABAP = 'ABAP',
  CORPORATE_CONTENT = 'CORPORATE_CONTENT',
  DITA = 'DITA',
  MARKETING = 'MARKETING',
  NON_ABAP = 'NON_ABAP',
  NOTES = 'NOTES',
  TRAINING = 'TRAINING'
}

export type User = {
  __typename?: 'User';
  accessLevel: ResourceAccessLevel;
  displayName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  internal: Scalars['Boolean'];
  lastName: Scalars['String'];
  sapNumber?: Maybe<Scalars['String']>;
  supplierLanguages?: Maybe<UserSupplierLanguages>;
  suppliers: Array<Supplier>;
  username: Scalars['String'];
};

export type UserSupplierLanguages = {
  __typename?: 'UserSupplierLanguages';
  code: Scalars['String'];
  languages: Array<Scalars['String']>;
  name: Scalars['String'];
};

export enum Worklist {
  PRIORITY = 'PRIORITY',
  SECURITY = 'SECURITY',
  STANDARD = 'STANDARD'
}

export type AbapQueryDetailsFragment = {
  __typename?: 'AbapQuery';
  id: string;
  system: string;
  objectType: string;
  objectName: string;
  objectOwner?: string | null;
  collectionPackage: string;
  collectionOwner?: string | null;
  applicationComponent: string;
  repositoryProgramType: string;
  repositoryProgramId: string;
  repositoryProgramName: string;
  translationArea: string;
  languagesTranslatorTeams?: string | null;
  maxLength?: number | null;
};

export type BaseQueryDetailsFragment = {
  __typename?: 'BaseQuery';
  id: string;
  qtId?: number | null;
  deadline: string;
  status: Status;
  sourceText?: string | null;
  targetText?: string | null;
  targetLanguage: string;
  issueType: IssueType;
  details?: string | null;
  assignee?: string | null;
  submitterGroupName?: string | null;
  translationType: TranslationType;
  createdAt: any;
  qeReview: boolean;
  forwardReviewTo?: ForwardReview | null;
  assignedTo?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    displayName: string;
    accessLevel: ResourceAccessLevel;
    sapNumber?: string | null;
  } | null;
  project: {
    __typename?: 'Project';
    projectName: string;
    id: string;
    name: string;
    projectManager?: string | null;
    qualityExpert?: string | null;
    queryResponsible?: string | null;
    deadline?: string | null;
    stakeholders?: Array<{
      __typename?: 'ProjectStakeholder';
      id: string;
      stakeholderRole: StakeholderRole;
      userName: string;
      displayName?: string | null;
    }> | null;
    languages: Array<{
      __typename?: 'ProjectLanguage';
      id: string;
      language: string;
      supplier: string;
      deadline?: any | null;
    } | null>;
  };
  attachments: Array<{
    __typename?: 'Attachment';
    id: string;
    name: string;
    createdAt: any;
    uploadedBy: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      displayName: string;
      accessLevel: ResourceAccessLevel;
      sapNumber?: string | null;
    };
  }>;
  createdBy: {
    __typename?: 'User';
    accessLevel: ResourceAccessLevel;
    internal: boolean;
    id: string;
    firstName: string;
    lastName: string;
    displayName: string;
    sapNumber?: string | null;
  };
  comments: Array<{
    __typename?: 'QueryComment';
    id: string;
    commentText: string;
    commentType: CommentType;
    createdAt: any;
    updatedAt: any;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      displayName: string;
      accessLevel: ResourceAccessLevel;
      supplierLanguages?: {
        __typename?: 'UserSupplierLanguages';
        name: string;
        code: string;
        languages: Array<string>;
      } | null;
    };
  }>;
  distributions: Array<{
    __typename?: 'Distribution';
    id: string;
    status: DistributionStatus;
    updatedAt: any;
    distribute: boolean;
    language: {
      __typename?: 'ProjectLanguage';
      id: string;
      language: string;
      supplier: string;
      deadline?: any | null;
    };
  }>;
  languagesByQueryCreator: Array<{
    __typename?: 'ProjectLanguage';
    id: string;
    language: string;
  } | null>;
};

export type ColumnsFragment = {
  __typename?: 'ColumnConfig';
  id?: boolean | null;
  deadline?: boolean | null;
  status?: boolean | null;
  translation?: boolean | null;
  source?: boolean | null;
  issue?: boolean | null;
  language?: boolean | null;
  xtmProjectName?: boolean | null;
  filename?: boolean | null;
  projectName?: boolean | null;
  projectManager?: boolean | null;
  qualityExpert?: boolean | null;
  qmContact?: boolean | null;
  substitutePm?: boolean | null;
  assignee?: boolean | null;
  creator?: boolean | null;
  queryCreatedAt?: boolean | null;
  submitterGroupName?: boolean | null;
  loio?: boolean | null;
  repository?: boolean | null;
  collection?: boolean | null;
  stringId?: boolean | null;
  queryTrackerId?: boolean | null;
  account?: boolean | null;
  applicationComponent?: boolean | null;
  sourceContact?: boolean | null;
};

export type CommentFragment = {
  __typename?: 'QueryComment';
  id: string;
  commentText: string;
  commentType: CommentType;
  createdAt: any;
  updatedAt: any;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    displayName: string;
    accessLevel: ResourceAccessLevel;
    supplierLanguages?: {
      __typename?: 'UserSupplierLanguages';
      name: string;
      code: string;
      languages: Array<string>;
    } | null;
  };
};

export type CorporateContentQueryDetailsFragment = {
  __typename?: 'CorporateContentQuery';
  id: string;
  fileName: string;
  xtmProjectNameCC?: string | null;
};

export type DitaQueryDetailsFragment = {
  __typename?: 'DitaQuery';
  id: string;
  deliverable: string;
  cmsProject: string;
  fileTitle: string;
  submap?: string | null;
  loio: string;
  fileName: string;
  sourceContact: string;
  sourceContactDisplayName: string;
  languagesTranslatorTeams?: string | null;
  xtmProjectNameDita?: string | null;
};

export type LanguageWithSupplierFragment = {
  __typename?: 'ProjectLanguage';
  id: string;
  language: string;
  supplier: string;
  deadline?: any | null;
};

export type MarketingQueryDetailsFragment = {
  __typename?: 'MarketingQuery';
  id: string;
  account?: string | null;
  fileNameMkt?: string | null;
};

export type MsGraphUserDetailsFragment = {
  __typename?: 'MsGraphUser';
  id: string;
  displayName?: string | null;
  givenName?: string | null;
  surname?: string | null;
  mail?: string | null;
  userPrincipalName?: string | null;
  department?: string | null;
  sapNumber?: string | null;
  sapName?: string | null;
};

export type NonAbapQueryDetailsFragment = {
  __typename?: 'NonAbapQuery';
  id: string;
  xtmProjectName: string;
  repository: string;
  collection: string;
  fileName: string;
  stringId: string;
  sourceContact: string;
  sourceContactDisplayName: string;
  languagesTranslatorTeams?: string | null;
};

export type NotesQueryDetailsFragment = {
  __typename?: 'NotesQuery';
  id: string;
  documentNumber: string;
  component: string;
  documentType: DocumentType;
  worklist?: Worklist | null;
  documentResponsible?: string | null;
  documentResponsibleDisplayName?: string | null;
};

export type ProjectFieldsFragment = {
  __typename?: 'Project';
  id: string;
  name: string;
  projectManager?: string | null;
  qualityExpert?: string | null;
  queryResponsible?: string | null;
  projectName: string;
  stakeholders?: Array<{
    __typename?: 'ProjectStakeholder';
    id: string;
    stakeholderRole: StakeholderRole;
    userName: string;
    displayName?: string | null;
  }> | null;
};

export type ProjectStakeholderFragment = {
  __typename?: 'ProjectStakeholder';
  id: string;
  stakeholderRole: StakeholderRole;
  userName: string;
  displayName?: string | null;
};

export type ProjectWithLanguagesFragment = {
  __typename?: 'Project';
  id: string;
  name: string;
  projectManager?: string | null;
  qualityExpert?: string | null;
  queryResponsible?: string | null;
  languages: Array<{ __typename?: 'ProjectLanguage'; id: string; language: string } | null>;
};

export type ProjectWithLanguagesAndSupplierFragment = {
  __typename?: 'Project';
  id: string;
  name: string;
  projectManager?: string | null;
  qualityExpert?: string | null;
  queryResponsible?: string | null;
  deadline?: string | null;
  languages: Array<{
    __typename?: 'ProjectLanguage';
    id: string;
    language: string;
    supplier: string;
    deadline?: any | null;
  } | null>;
};

export type SearchFilterFieldDetailsFragment = {
  __typename?: 'SearchFilterField';
  key: string;
  value?: string | null;
  enabled: boolean;
};

export type SearchFilterDetailsFragment = {
  __typename?: 'SearchFilter';
  id: string;
  name: string;
  isDefault: boolean;
  favorite: boolean;
  isSubscribed: boolean;
  filters: Array<{
    __typename?: 'SearchFilterField';
    key: string;
    value?: string | null;
    enabled: boolean;
  }>;
  columnConfig?: {
    __typename?: 'ColumnConfig';
    id?: boolean | null;
    deadline?: boolean | null;
    status?: boolean | null;
    translation?: boolean | null;
    source?: boolean | null;
    issue?: boolean | null;
    language?: boolean | null;
    xtmProjectName?: boolean | null;
    filename?: boolean | null;
    projectName?: boolean | null;
    projectManager?: boolean | null;
    qualityExpert?: boolean | null;
    qmContact?: boolean | null;
    substitutePm?: boolean | null;
    assignee?: boolean | null;
    creator?: boolean | null;
    queryCreatedAt?: boolean | null;
    submitterGroupName?: boolean | null;
    loio?: boolean | null;
    repository?: boolean | null;
    collection?: boolean | null;
    stringId?: boolean | null;
    queryTrackerId?: boolean | null;
    account?: boolean | null;
    applicationComponent?: boolean | null;
    sourceContact?: boolean | null;
  } | null;
};

export type SupplierDetailsFragment = {
  __typename?: 'Supplier';
  id: string;
  vendor: string;
  name: string;
};

export type TrainingQueryDetailsFragment = {
  __typename?: 'TrainingQuery';
  id: string;
  xtmProjectName: string;
  fileName: string;
};

export type UserNameFragment = {
  __typename?: 'User';
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  accessLevel: ResourceAccessLevel;
  sapNumber?: string | null;
};

export type AddAnswerToQueryMutationVariables = Exact<{
  input: QueryAnswerInput;
  isInternal?: Scalars['Boolean'];
}>;

export type AddAnswerToQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'BaseQuery';
    id: string;
    status: Status;
    assignee?: string | null;
    comments: Array<{
      __typename?: 'QueryComment';
      id: string;
      commentText: string;
      commentType: CommentType;
      createdAt: any;
      updatedAt: any;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        supplierLanguages?: {
          __typename?: 'UserSupplierLanguages';
          name: string;
          code: string;
          languages: Array<string>;
        } | null;
      };
    }>;
    distributions: Array<{
      __typename?: 'Distribution';
      id: string;
      status: DistributionStatus;
      updatedAt: any;
      distribute: boolean;
      language: {
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
        supplier: string;
        deadline?: any | null;
      };
    }>;
  };
};

export type AddCommentToQueryMutationVariables = Exact<{
  input: QueryCommentInput;
}>;

export type AddCommentToQueryMutation = {
  __typename?: 'Mutation';
  comment: {
    __typename?: 'QueryComment';
    id: string;
    commentText: string;
    commentType: CommentType;
    createdAt: any;
    updatedAt: any;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      displayName: string;
      accessLevel: ResourceAccessLevel;
      supplierLanguages?: {
        __typename?: 'UserSupplierLanguages';
        name: string;
        code: string;
        languages: Array<string>;
      } | null;
    };
  };
};

export type ClarifyQueryMutationVariables = Exact<{
  input: ClarifyQueryInput;
}>;

export type ClarifyQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'BaseQuery';
    id: string;
    status: Status;
    comments: Array<{
      __typename?: 'QueryComment';
      id: string;
      commentText: string;
      commentType: CommentType;
      createdAt: any;
      updatedAt: any;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        supplierLanguages?: {
          __typename?: 'UserSupplierLanguages';
          name: string;
          code: string;
          languages: Array<string>;
        } | null;
      };
    }>;
  };
};

export type CompleteDistributionMutationVariables = Exact<{
  input: CompleteDistributionInput;
}>;

export type CompleteDistributionMutation = {
  __typename?: 'Mutation';
  distribution: {
    __typename?: 'Distribution';
    id: string;
    status: DistributionStatus;
    updatedAt: any;
    query?: {
      __typename?: 'BaseQuery';
      id: string;
      status: Status;
      comments: Array<{
        __typename?: 'QueryComment';
        id: string;
        commentText: string;
        commentType: CommentType;
        createdAt: any;
        updatedAt: any;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          supplierLanguages?: {
            __typename?: 'UserSupplierLanguages';
            name: string;
            code: string;
            languages: Array<string>;
          } | null;
        };
      }>;
    } | null;
  };
};

export type CompleteAnsweredQueryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CompleteAnsweredQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'BaseQuery';
    id: string;
    status: Status;
    comments: Array<{
      __typename?: 'QueryComment';
      id: string;
      commentText: string;
      commentType: CommentType;
      createdAt: any;
      updatedAt: any;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        supplierLanguages?: {
          __typename?: 'UserSupplierLanguages';
          name: string;
          code: string;
          languages: Array<string>;
        } | null;
      };
    }>;
  };
};

export type CreateAbapMutationVariables = Exact<{
  input: AbapInput;
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;

export type CreateAbapMutation = {
  __typename?: 'Mutation';
  query: { __typename?: 'AbapQuery'; id: string };
};

export type CreateCorporateContentMutationVariables = Exact<{
  input: CorporateContentInput;
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;

export type CreateCorporateContentMutation = {
  __typename?: 'Mutation';
  query: { __typename?: 'CorporateContentQuery'; id: string };
};

export type CreateDitaMutationVariables = Exact<{
  input: DitaInput;
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;

export type CreateDitaMutation = {
  __typename?: 'Mutation';
  query: { __typename?: 'DitaQuery'; id: string };
};

export type CreateMarketingMutationVariables = Exact<{
  input: MarketingInput;
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;

export type CreateMarketingMutation = {
  __typename?: 'Mutation';
  query: { __typename?: 'MarketingQuery'; id: string };
};

export type CreateNonAbapMutationVariables = Exact<{
  input: NonAbapInput;
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;

export type CreateNonAbapMutation = {
  __typename?: 'Mutation';
  query: { __typename?: 'NonAbapQuery'; id: string };
};

export type CreateNotesMutationVariables = Exact<{
  input: NotesInput;
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;

export type CreateNotesMutation = {
  __typename?: 'Mutation';
  query: { __typename?: 'NotesQuery'; id: string };
};

export type CreateSearchFilterMutationVariables = Exact<{
  input: SearchFilterCreate;
}>;

export type CreateSearchFilterMutation = {
  __typename?: 'Mutation';
  mutation: {
    __typename?: 'SearchFilter';
    id: string;
    name: string;
    isDefault: boolean;
    favorite: boolean;
    isSubscribed: boolean;
    filters: Array<{
      __typename?: 'SearchFilterField';
      key: string;
      value?: string | null;
      enabled: boolean;
    }>;
    columnConfig?: {
      __typename?: 'ColumnConfig';
      id?: boolean | null;
      deadline?: boolean | null;
      status?: boolean | null;
      translation?: boolean | null;
      source?: boolean | null;
      issue?: boolean | null;
      language?: boolean | null;
      xtmProjectName?: boolean | null;
      filename?: boolean | null;
      projectName?: boolean | null;
      projectManager?: boolean | null;
      qualityExpert?: boolean | null;
      qmContact?: boolean | null;
      substitutePm?: boolean | null;
      assignee?: boolean | null;
      creator?: boolean | null;
      queryCreatedAt?: boolean | null;
      submitterGroupName?: boolean | null;
      loio?: boolean | null;
      repository?: boolean | null;
      collection?: boolean | null;
      stringId?: boolean | null;
      queryTrackerId?: boolean | null;
      account?: boolean | null;
      applicationComponent?: boolean | null;
      sourceContact?: boolean | null;
    } | null;
  };
};

export type CreateTrainingMutationVariables = Exact<{
  input: TrainingInput;
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;

export type CreateTrainingMutation = {
  __typename?: 'Mutation';
  query: { __typename?: 'TrainingQuery'; id: string };
};

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteFileMutation = { __typename?: 'Mutation'; deleteFile: boolean };

export type DeleteQueryByIdMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteQueryByIdMutation = { __typename?: 'Mutation'; deleteQueryById: boolean };

export type DiscontinueQueryByIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DiscontinueQueryByIdMutation = {
  __typename?: 'Mutation';
  query: { __typename?: 'BaseQuery'; id: string; status: Status };
};

export type DistributeQueryMutationVariables = Exact<{
  id: Scalars['ID'];
  isInternal?: Scalars['Boolean'];
}>;

export type DistributeQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'BaseQuery';
    id: string;
    status: Status;
    comments: Array<{
      __typename?: 'QueryComment';
      id: string;
      commentText: string;
      commentType: CommentType;
      createdAt: any;
      updatedAt: any;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        supplierLanguages?: {
          __typename?: 'UserSupplierLanguages';
          name: string;
          code: string;
          languages: Array<string>;
        } | null;
      };
    }>;
    distributions: Array<{
      __typename?: 'Distribution';
      id: string;
      status: DistributionStatus;
      updatedAt: any;
      distribute: boolean;
      language: {
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
        supplier: string;
        deadline?: any | null;
      };
    }>;
  };
};

export type ForwardToAnswererMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ForwardToAnswererMutation = {
  __typename?: 'Mutation';
  forwardToAnswerer: {
    __typename?: 'BaseQuery';
    id: string;
    status: Status;
    comments: Array<{
      __typename?: 'QueryComment';
      id: string;
      commentText: string;
      commentType: CommentType;
      createdAt: any;
      updatedAt: any;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        supplierLanguages?: {
          __typename?: 'UserSupplierLanguages';
          name: string;
          code: string;
          languages: Array<string>;
        } | null;
      };
    }>;
  };
};

export type ForwardToCreatorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ForwardToCreatorMutation = {
  __typename?: 'Mutation';
  forwardToCreator: {
    __typename?: 'BaseQuery';
    id: string;
    status: Status;
    comments: Array<{
      __typename?: 'QueryComment';
      id: string;
      commentText: string;
      commentType: CommentType;
      createdAt: any;
      updatedAt: any;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        supplierLanguages?: {
          __typename?: 'UserSupplierLanguages';
          name: string;
          code: string;
          languages: Array<string>;
        } | null;
      };
    }>;
  };
};

export type ImportAbapQueriesMutationVariables = Exact<{
  projects: Array<Scalars['String']> | Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;

export type ImportAbapQueriesMutation = {
  __typename?: 'Mutation';
  importAbapQueries: Array<{
    __typename?: 'QTImport';
    id: string;
    status: QtImportStatus;
    fileName: string;
    details?: string | null;
    createdAt: any;
    finishedAt?: any | null;
    updatedAt: any;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      displayName: string;
      accessLevel: ResourceAccessLevel;
      sapNumber?: string | null;
    };
  }>;
};

export type ImportFileMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;

export type ImportFileMutation = {
  __typename?: 'Mutation';
  importFile: {
    __typename?: 'QTImport';
    id: string;
    status: QtImportStatus;
    fileName: string;
    details?: string | null;
    finishedAt?: any | null;
    createdAt: any;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      displayName: string;
      accessLevel: ResourceAccessLevel;
      sapNumber?: string | null;
    };
  };
};

export type RequestClarificationMutationVariables = Exact<{
  input: RequestClarificationInput;
}>;

export type RequestClarificationMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'BaseQuery';
    id: string;
    status: Status;
    forwardReviewTo?: ForwardReview | null;
    comments: Array<{
      __typename?: 'QueryComment';
      id: string;
      commentText: string;
      commentType: CommentType;
      createdAt: any;
      updatedAt: any;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        supplierLanguages?: {
          __typename?: 'UserSupplierLanguages';
          name: string;
          code: string;
          languages: Array<string>;
        } | null;
      };
    }>;
  };
};

export type SendEmailNotificationMutationVariables = Exact<{
  email: EmailInput;
}>;

export type SendEmailNotificationMutation = { __typename?: 'Mutation'; result: boolean };

export type SubscribeViewsMutationVariables = Exact<{
  searchFilters: Array<SearchFilterSubscribe> | SearchFilterSubscribe;
}>;

export type SubscribeViewsMutation = {
  __typename?: 'Mutation';
  mutation: Array<{
    __typename?: 'SearchFilter';
    id: string;
    name: string;
    isDefault: boolean;
    favorite: boolean;
    isSubscribed: boolean;
    filters: Array<{
      __typename?: 'SearchFilterField';
      key: string;
      value?: string | null;
      enabled: boolean;
    }>;
    columnConfig?: {
      __typename?: 'ColumnConfig';
      id?: boolean | null;
      deadline?: boolean | null;
      status?: boolean | null;
      translation?: boolean | null;
      source?: boolean | null;
      issue?: boolean | null;
      language?: boolean | null;
      xtmProjectName?: boolean | null;
      filename?: boolean | null;
      projectName?: boolean | null;
      projectManager?: boolean | null;
      qualityExpert?: boolean | null;
      qmContact?: boolean | null;
      substitutePm?: boolean | null;
      assignee?: boolean | null;
      creator?: boolean | null;
      queryCreatedAt?: boolean | null;
      submitterGroupName?: boolean | null;
      loio?: boolean | null;
      repository?: boolean | null;
      collection?: boolean | null;
      stringId?: boolean | null;
      queryTrackerId?: boolean | null;
      account?: boolean | null;
      applicationComponent?: boolean | null;
      sourceContact?: boolean | null;
    } | null;
  }>;
};

export type UpdateAbapQueryMutationVariables = Exact<{
  input: AbapInputUpdate;
  isInternal?: Scalars['Boolean'];
}>;

export type UpdateAbapQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'AbapQuery';
    id: string;
    system: string;
    objectType: string;
    objectName: string;
    objectOwner?: string | null;
    collectionPackage: string;
    collectionOwner?: string | null;
    applicationComponent: string;
    repositoryProgramType: string;
    repositoryProgramId: string;
    repositoryProgramName: string;
    translationArea: string;
    languagesTranslatorTeams?: string | null;
    maxLength?: number | null;
    baseQuery: {
      __typename?: 'BaseQuery';
      id: string;
      qtId?: number | null;
      deadline: string;
      status: Status;
      sourceText?: string | null;
      targetText?: string | null;
      targetLanguage: string;
      issueType: IssueType;
      details?: string | null;
      assignee?: string | null;
      submitterGroupName?: string | null;
      translationType: TranslationType;
      createdAt: any;
      qeReview: boolean;
      forwardReviewTo?: ForwardReview | null;
      assignedTo?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        sapNumber?: string | null;
      } | null;
      project: {
        __typename?: 'Project';
        projectName: string;
        id: string;
        name: string;
        projectManager?: string | null;
        qualityExpert?: string | null;
        queryResponsible?: string | null;
        deadline?: string | null;
        stakeholders?: Array<{
          __typename?: 'ProjectStakeholder';
          id: string;
          stakeholderRole: StakeholderRole;
          userName: string;
          displayName?: string | null;
        }> | null;
        languages: Array<{
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        } | null>;
      };
      attachments: Array<{
        __typename?: 'Attachment';
        id: string;
        name: string;
        createdAt: any;
        uploadedBy: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          sapNumber?: string | null;
        };
      }>;
      createdBy: {
        __typename?: 'User';
        accessLevel: ResourceAccessLevel;
        internal: boolean;
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        sapNumber?: string | null;
      };
      comments: Array<{
        __typename?: 'QueryComment';
        id: string;
        commentText: string;
        commentType: CommentType;
        createdAt: any;
        updatedAt: any;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          supplierLanguages?: {
            __typename?: 'UserSupplierLanguages';
            name: string;
            code: string;
            languages: Array<string>;
          } | null;
        };
      }>;
      distributions: Array<{
        __typename?: 'Distribution';
        id: string;
        status: DistributionStatus;
        updatedAt: any;
        distribute: boolean;
        language: {
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        };
      }>;
      languagesByQueryCreator: Array<{
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
      } | null>;
    };
  };
};

export type UpdateAssigneeMutationVariables = Exact<{
  input: BaseQueryAssigneeInputUpdate;
}>;

export type UpdateAssigneeMutation = {
  __typename?: 'Mutation';
  queries: Array<{
    __typename?: 'BaseQuery';
    id: string;
    assignee?: string | null;
    status: Status;
  }>;
};

export type UpdateCorporateContentQueryMutationVariables = Exact<{
  input: CorporateContentInputUpdate;
  isInternal?: Scalars['Boolean'];
}>;

export type UpdateCorporateContentQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'CorporateContentQuery';
    id: string;
    fileName: string;
    xtmProjectNameCC?: string | null;
    baseQuery: {
      __typename?: 'BaseQuery';
      id: string;
      qtId?: number | null;
      deadline: string;
      status: Status;
      sourceText?: string | null;
      targetText?: string | null;
      targetLanguage: string;
      issueType: IssueType;
      details?: string | null;
      assignee?: string | null;
      submitterGroupName?: string | null;
      translationType: TranslationType;
      createdAt: any;
      qeReview: boolean;
      forwardReviewTo?: ForwardReview | null;
      assignedTo?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        sapNumber?: string | null;
      } | null;
      project: {
        __typename?: 'Project';
        projectName: string;
        id: string;
        name: string;
        projectManager?: string | null;
        qualityExpert?: string | null;
        queryResponsible?: string | null;
        deadline?: string | null;
        stakeholders?: Array<{
          __typename?: 'ProjectStakeholder';
          id: string;
          stakeholderRole: StakeholderRole;
          userName: string;
          displayName?: string | null;
        }> | null;
        languages: Array<{
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        } | null>;
      };
      attachments: Array<{
        __typename?: 'Attachment';
        id: string;
        name: string;
        createdAt: any;
        uploadedBy: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          sapNumber?: string | null;
        };
      }>;
      createdBy: {
        __typename?: 'User';
        accessLevel: ResourceAccessLevel;
        internal: boolean;
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        sapNumber?: string | null;
      };
      comments: Array<{
        __typename?: 'QueryComment';
        id: string;
        commentText: string;
        commentType: CommentType;
        createdAt: any;
        updatedAt: any;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          supplierLanguages?: {
            __typename?: 'UserSupplierLanguages';
            name: string;
            code: string;
            languages: Array<string>;
          } | null;
        };
      }>;
      distributions: Array<{
        __typename?: 'Distribution';
        id: string;
        status: DistributionStatus;
        updatedAt: any;
        distribute: boolean;
        language: {
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        };
      }>;
      languagesByQueryCreator: Array<{
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
      } | null>;
    };
  };
};

export type UpdateDitaQueryMutationVariables = Exact<{
  input: DitaInputUpdate;
  isInternal?: Scalars['Boolean'];
}>;

export type UpdateDitaQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'DitaQuery';
    id: string;
    deliverable: string;
    cmsProject: string;
    fileTitle: string;
    submap?: string | null;
    loio: string;
    fileName: string;
    sourceContact: string;
    sourceContactDisplayName: string;
    languagesTranslatorTeams?: string | null;
    xtmProjectNameDita?: string | null;
    baseQuery: {
      __typename?: 'BaseQuery';
      id: string;
      qtId?: number | null;
      deadline: string;
      status: Status;
      sourceText?: string | null;
      targetText?: string | null;
      targetLanguage: string;
      issueType: IssueType;
      details?: string | null;
      assignee?: string | null;
      submitterGroupName?: string | null;
      translationType: TranslationType;
      createdAt: any;
      qeReview: boolean;
      forwardReviewTo?: ForwardReview | null;
      assignedTo?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        sapNumber?: string | null;
      } | null;
      project: {
        __typename?: 'Project';
        projectName: string;
        id: string;
        name: string;
        projectManager?: string | null;
        qualityExpert?: string | null;
        queryResponsible?: string | null;
        deadline?: string | null;
        stakeholders?: Array<{
          __typename?: 'ProjectStakeholder';
          id: string;
          stakeholderRole: StakeholderRole;
          userName: string;
          displayName?: string | null;
        }> | null;
        languages: Array<{
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        } | null>;
      };
      attachments: Array<{
        __typename?: 'Attachment';
        id: string;
        name: string;
        createdAt: any;
        uploadedBy: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          sapNumber?: string | null;
        };
      }>;
      createdBy: {
        __typename?: 'User';
        accessLevel: ResourceAccessLevel;
        internal: boolean;
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        sapNumber?: string | null;
      };
      comments: Array<{
        __typename?: 'QueryComment';
        id: string;
        commentText: string;
        commentType: CommentType;
        createdAt: any;
        updatedAt: any;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          supplierLanguages?: {
            __typename?: 'UserSupplierLanguages';
            name: string;
            code: string;
            languages: Array<string>;
          } | null;
        };
      }>;
      distributions: Array<{
        __typename?: 'Distribution';
        id: string;
        status: DistributionStatus;
        updatedAt: any;
        distribute: boolean;
        language: {
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        };
      }>;
      languagesByQueryCreator: Array<{
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
      } | null>;
    };
  };
};

export type UpdateMarketingQueryMutationVariables = Exact<{
  input: MarketingInputUpdate;
  isInternal?: Scalars['Boolean'];
}>;

export type UpdateMarketingQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'MarketingQuery';
    id: string;
    account?: string | null;
    fileNameMkt?: string | null;
    baseQuery: {
      __typename?: 'BaseQuery';
      id: string;
      qtId?: number | null;
      deadline: string;
      status: Status;
      sourceText?: string | null;
      targetText?: string | null;
      targetLanguage: string;
      issueType: IssueType;
      details?: string | null;
      assignee?: string | null;
      submitterGroupName?: string | null;
      translationType: TranslationType;
      createdAt: any;
      qeReview: boolean;
      forwardReviewTo?: ForwardReview | null;
      assignedTo?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        sapNumber?: string | null;
      } | null;
      project: {
        __typename?: 'Project';
        projectName: string;
        id: string;
        name: string;
        projectManager?: string | null;
        qualityExpert?: string | null;
        queryResponsible?: string | null;
        deadline?: string | null;
        stakeholders?: Array<{
          __typename?: 'ProjectStakeholder';
          id: string;
          stakeholderRole: StakeholderRole;
          userName: string;
          displayName?: string | null;
        }> | null;
        languages: Array<{
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        } | null>;
      };
      attachments: Array<{
        __typename?: 'Attachment';
        id: string;
        name: string;
        createdAt: any;
        uploadedBy: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          sapNumber?: string | null;
        };
      }>;
      createdBy: {
        __typename?: 'User';
        accessLevel: ResourceAccessLevel;
        internal: boolean;
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        sapNumber?: string | null;
      };
      comments: Array<{
        __typename?: 'QueryComment';
        id: string;
        commentText: string;
        commentType: CommentType;
        createdAt: any;
        updatedAt: any;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          supplierLanguages?: {
            __typename?: 'UserSupplierLanguages';
            name: string;
            code: string;
            languages: Array<string>;
          } | null;
        };
      }>;
      distributions: Array<{
        __typename?: 'Distribution';
        id: string;
        status: DistributionStatus;
        updatedAt: any;
        distribute: boolean;
        language: {
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        };
      }>;
      languagesByQueryCreator: Array<{
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
      } | null>;
    };
  };
};

export type UpdateNonAbapQueryMutationVariables = Exact<{
  input: NonAbapInputUpdate;
  isInternal?: Scalars['Boolean'];
}>;

export type UpdateNonAbapQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'NonAbapQuery';
    id: string;
    xtmProjectName: string;
    repository: string;
    collection: string;
    fileName: string;
    stringId: string;
    sourceContact: string;
    sourceContactDisplayName: string;
    languagesTranslatorTeams?: string | null;
    baseQuery: {
      __typename?: 'BaseQuery';
      id: string;
      qtId?: number | null;
      deadline: string;
      status: Status;
      sourceText?: string | null;
      targetText?: string | null;
      targetLanguage: string;
      issueType: IssueType;
      details?: string | null;
      assignee?: string | null;
      submitterGroupName?: string | null;
      translationType: TranslationType;
      createdAt: any;
      qeReview: boolean;
      forwardReviewTo?: ForwardReview | null;
      assignedTo?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        sapNumber?: string | null;
      } | null;
      project: {
        __typename?: 'Project';
        projectName: string;
        id: string;
        name: string;
        projectManager?: string | null;
        qualityExpert?: string | null;
        queryResponsible?: string | null;
        deadline?: string | null;
        stakeholders?: Array<{
          __typename?: 'ProjectStakeholder';
          id: string;
          stakeholderRole: StakeholderRole;
          userName: string;
          displayName?: string | null;
        }> | null;
        languages: Array<{
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        } | null>;
      };
      attachments: Array<{
        __typename?: 'Attachment';
        id: string;
        name: string;
        createdAt: any;
        uploadedBy: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          sapNumber?: string | null;
        };
      }>;
      createdBy: {
        __typename?: 'User';
        accessLevel: ResourceAccessLevel;
        internal: boolean;
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        sapNumber?: string | null;
      };
      comments: Array<{
        __typename?: 'QueryComment';
        id: string;
        commentText: string;
        commentType: CommentType;
        createdAt: any;
        updatedAt: any;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          supplierLanguages?: {
            __typename?: 'UserSupplierLanguages';
            name: string;
            code: string;
            languages: Array<string>;
          } | null;
        };
      }>;
      distributions: Array<{
        __typename?: 'Distribution';
        id: string;
        status: DistributionStatus;
        updatedAt: any;
        distribute: boolean;
        language: {
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        };
      }>;
      languagesByQueryCreator: Array<{
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
      } | null>;
    };
  };
};

export type UpdateNotesQueryMutationVariables = Exact<{
  input: NotesInputUpdate;
  isInternal?: Scalars['Boolean'];
}>;

export type UpdateNotesQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'NotesQuery';
    id: string;
    documentNumber: string;
    component: string;
    documentType: DocumentType;
    worklist?: Worklist | null;
    documentResponsible?: string | null;
    documentResponsibleDisplayName?: string | null;
    baseQuery: {
      __typename?: 'BaseQuery';
      id: string;
      qtId?: number | null;
      deadline: string;
      status: Status;
      sourceText?: string | null;
      targetText?: string | null;
      targetLanguage: string;
      issueType: IssueType;
      details?: string | null;
      assignee?: string | null;
      submitterGroupName?: string | null;
      translationType: TranslationType;
      createdAt: any;
      qeReview: boolean;
      forwardReviewTo?: ForwardReview | null;
      assignedTo?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        sapNumber?: string | null;
      } | null;
      project: {
        __typename?: 'Project';
        projectName: string;
        id: string;
        name: string;
        projectManager?: string | null;
        qualityExpert?: string | null;
        queryResponsible?: string | null;
        deadline?: string | null;
        stakeholders?: Array<{
          __typename?: 'ProjectStakeholder';
          id: string;
          stakeholderRole: StakeholderRole;
          userName: string;
          displayName?: string | null;
        }> | null;
        languages: Array<{
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        } | null>;
      };
      attachments: Array<{
        __typename?: 'Attachment';
        id: string;
        name: string;
        createdAt: any;
        uploadedBy: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          sapNumber?: string | null;
        };
      }>;
      createdBy: {
        __typename?: 'User';
        accessLevel: ResourceAccessLevel;
        internal: boolean;
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        sapNumber?: string | null;
      };
      comments: Array<{
        __typename?: 'QueryComment';
        id: string;
        commentText: string;
        commentType: CommentType;
        createdAt: any;
        updatedAt: any;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          supplierLanguages?: {
            __typename?: 'UserSupplierLanguages';
            name: string;
            code: string;
            languages: Array<string>;
          } | null;
        };
      }>;
      distributions: Array<{
        __typename?: 'Distribution';
        id: string;
        status: DistributionStatus;
        updatedAt: any;
        distribute: boolean;
        language: {
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        };
      }>;
      languagesByQueryCreator: Array<{
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
      } | null>;
    };
  };
};

export type UpdateSearchFilterMutationVariables = Exact<{
  input: SearchFilterUpdate;
}>;

export type UpdateSearchFilterMutation = {
  __typename?: 'Mutation';
  mutation: {
    __typename?: 'SearchFilter';
    id: string;
    name: string;
    isDefault: boolean;
    favorite: boolean;
    isSubscribed: boolean;
    filters: Array<{
      __typename?: 'SearchFilterField';
      key: string;
      value?: string | null;
      enabled: boolean;
    }>;
    columnConfig?: {
      __typename?: 'ColumnConfig';
      id?: boolean | null;
      deadline?: boolean | null;
      status?: boolean | null;
      translation?: boolean | null;
      source?: boolean | null;
      issue?: boolean | null;
      language?: boolean | null;
      xtmProjectName?: boolean | null;
      filename?: boolean | null;
      projectName?: boolean | null;
      projectManager?: boolean | null;
      qualityExpert?: boolean | null;
      qmContact?: boolean | null;
      substitutePm?: boolean | null;
      assignee?: boolean | null;
      creator?: boolean | null;
      queryCreatedAt?: boolean | null;
      submitterGroupName?: boolean | null;
      loio?: boolean | null;
      repository?: boolean | null;
      collection?: boolean | null;
      stringId?: boolean | null;
      queryTrackerId?: boolean | null;
      account?: boolean | null;
      applicationComponent?: boolean | null;
      sourceContact?: boolean | null;
    } | null;
  };
};

export type UpdateSearchFiltersMutationVariables = Exact<{
  update: Array<SearchFilterUpdate> | SearchFilterUpdate;
  delete: Array<SearchFilterDelete> | SearchFilterDelete;
}>;

export type UpdateSearchFiltersMutation = {
  __typename?: 'Mutation';
  mutation: Array<{
    __typename?: 'SearchFilter';
    id: string;
    name: string;
    isDefault: boolean;
    favorite: boolean;
    isSubscribed: boolean;
    filters: Array<{
      __typename?: 'SearchFilterField';
      key: string;
      value?: string | null;
      enabled: boolean;
    }>;
    columnConfig?: {
      __typename?: 'ColumnConfig';
      id?: boolean | null;
      deadline?: boolean | null;
      status?: boolean | null;
      translation?: boolean | null;
      source?: boolean | null;
      issue?: boolean | null;
      language?: boolean | null;
      xtmProjectName?: boolean | null;
      filename?: boolean | null;
      projectName?: boolean | null;
      projectManager?: boolean | null;
      qualityExpert?: boolean | null;
      qmContact?: boolean | null;
      substitutePm?: boolean | null;
      assignee?: boolean | null;
      creator?: boolean | null;
      queryCreatedAt?: boolean | null;
      submitterGroupName?: boolean | null;
      loio?: boolean | null;
      repository?: boolean | null;
      collection?: boolean | null;
      stringId?: boolean | null;
      queryTrackerId?: boolean | null;
      account?: boolean | null;
      applicationComponent?: boolean | null;
      sourceContact?: boolean | null;
    } | null;
  }>;
};

export type UpdateTrainingQueryMutationVariables = Exact<{
  input: TrainingInputUpdate;
  isInternal?: Scalars['Boolean'];
}>;

export type UpdateTrainingQueryMutation = {
  __typename?: 'Mutation';
  query: {
    __typename?: 'TrainingQuery';
    id: string;
    xtmProjectName: string;
    fileName: string;
    baseQuery: {
      __typename?: 'BaseQuery';
      id: string;
      qtId?: number | null;
      deadline: string;
      status: Status;
      sourceText?: string | null;
      targetText?: string | null;
      targetLanguage: string;
      issueType: IssueType;
      details?: string | null;
      assignee?: string | null;
      submitterGroupName?: string | null;
      translationType: TranslationType;
      createdAt: any;
      qeReview: boolean;
      forwardReviewTo?: ForwardReview | null;
      assignedTo?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        sapNumber?: string | null;
      } | null;
      project: {
        __typename?: 'Project';
        projectName: string;
        id: string;
        name: string;
        projectManager?: string | null;
        qualityExpert?: string | null;
        queryResponsible?: string | null;
        deadline?: string | null;
        stakeholders?: Array<{
          __typename?: 'ProjectStakeholder';
          id: string;
          stakeholderRole: StakeholderRole;
          userName: string;
          displayName?: string | null;
        }> | null;
        languages: Array<{
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        } | null>;
      };
      attachments: Array<{
        __typename?: 'Attachment';
        id: string;
        name: string;
        createdAt: any;
        uploadedBy: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          sapNumber?: string | null;
        };
      }>;
      createdBy: {
        __typename?: 'User';
        accessLevel: ResourceAccessLevel;
        internal: boolean;
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        sapNumber?: string | null;
      };
      comments: Array<{
        __typename?: 'QueryComment';
        id: string;
        commentText: string;
        commentType: CommentType;
        createdAt: any;
        updatedAt: any;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          supplierLanguages?: {
            __typename?: 'UserSupplierLanguages';
            name: string;
            code: string;
            languages: Array<string>;
          } | null;
        };
      }>;
      distributions: Array<{
        __typename?: 'Distribution';
        id: string;
        status: DistributionStatus;
        updatedAt: any;
        distribute: boolean;
        language: {
          __typename?: 'ProjectLanguage';
          id: string;
          language: string;
          supplier: string;
          deadline?: any | null;
        };
      }>;
      languagesByQueryCreator: Array<{
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
      } | null>;
    };
  };
};

export type UpdateUserSupplierMutationVariables = Exact<{
  input: Array<SupplierInput> | SupplierInput;
  internal: Scalars['Boolean'];
}>;

export type UpdateUserSupplierMutation = {
  __typename?: 'Mutation';
  updateUserSupplier?: {
    __typename?: 'User';
    id: string;
    internal: boolean;
    suppliers: Array<{ __typename?: 'Supplier'; id: string; vendor: string; name: string }>;
  } | null;
};

export type UploadFileMutationVariables = Exact<{
  id: Scalars['ID'];
  file: Scalars['Upload'];
}>;

export type UploadFileMutation = {
  __typename?: 'Mutation';
  uploadFile: {
    __typename?: 'AttachmentResponse';
    attachment?: { __typename?: 'Attachment'; id: string } | null;
  };
};

export type GetAllProjectNamesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllProjectNamesQuery = {
  __typename?: 'Query';
  projects: Array<{ __typename?: 'Project'; id: string; projectName: string }>;
};

export type GetAllQueryTrackerImportsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllQueryTrackerImportsQuery = {
  __typename?: 'Query';
  qtImports: Array<{
    __typename?: 'QTImport';
    id: string;
    status: QtImportStatus;
    fileName: string;
    details?: string | null;
    finishedAt?: any | null;
    createdAt: any;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      displayName: string;
      accessLevel: ResourceAccessLevel;
      sapNumber?: string | null;
    };
  }>;
};

export type GetAttachmentUrlQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetAttachmentUrlQuery = {
  __typename?: 'Query';
  attachment: { __typename?: 'AttachmentSignedUrlResponse'; url: string };
};

export type GetMsGraphUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetMsGraphUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'MsGraphUser';
    id: string;
    displayName?: string | null;
    givenName?: string | null;
    surname?: string | null;
    mail?: string | null;
    userPrincipalName?: string | null;
    department?: string | null;
    sapNumber?: string | null;
    sapName?: string | null;
  } | null;
};

export type GetMsGraphUsersSearchByQueryQueryVariables = Exact<{
  query: Scalars['String'];
}>;

export type GetMsGraphUsersSearchByQueryQuery = {
  __typename?: 'Query';
  users?: Array<{
    __typename?: 'MsGraphUser';
    id: string;
    displayName?: string | null;
    givenName?: string | null;
    surname?: string | null;
    mail?: string | null;
    userPrincipalName?: string | null;
    department?: string | null;
    sapNumber?: string | null;
    sapName?: string | null;
  }> | null;
};

export type GetProjectDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetProjectDetailsQuery = {
  __typename?: 'Query';
  project?: {
    __typename?: 'Project';
    id: string;
    projectManager?: string | null;
    deadline?: string | null;
  } | null;
};

export type GetProjectsByTranslationTypeQueryVariables = Exact<{
  translationType: TranslationType;
}>;

export type GetProjectsByTranslationTypeQuery = {
  __typename?: 'Query';
  projects: Array<{
    __typename?: 'Project';
    id: string;
    name: string;
    projectName: string;
    projectId: string;
    deadline?: string | null;
    englishDeadline?: string | null;
    languages: Array<{ __typename?: 'ProjectLanguage'; id: string; language: string } | null>;
  }>;
};

export type GetQtProjectImportQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;

export type GetQtProjectImportQuery = {
  __typename?: 'Query';
  projects: Array<{ __typename?: 'QTProjectImport'; projectName: string; numberOfQueries: number }>;
};

export type GetQueriesPageQueryVariables = Exact<{
  limit: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<BaseQueryFilters>;
  isInternal?: Scalars['Boolean'];
}>;

export type GetQueriesPageQuery = {
  __typename?: 'Query';
  response: {
    __typename?: 'BaseQueryPage';
    total: number;
    edges?: Array<{
      __typename?: 'Edge';
      node: {
        __typename?: 'BaseQuery';
        id: string;
        qtId?: number | null;
        deadline: string;
        status: Status;
        qeReview: boolean;
        translationType: TranslationType;
        sourceText?: string | null;
        issueType: IssueType;
        targetLanguage: string;
        assignee?: string | null;
        submitterGroupName?: string | null;
        createdAt: any;
        project: {
          __typename?: 'Project';
          id: string;
          name: string;
          projectManager?: string | null;
          qualityExpert?: string | null;
          queryResponsible?: string | null;
          projectName: string;
          stakeholders?: Array<{
            __typename?: 'ProjectStakeholder';
            id: string;
            stakeholderRole: StakeholderRole;
            userName: string;
            displayName?: string | null;
          }> | null;
        };
        createdBy: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          sapNumber?: string | null;
        };
        assignedTo?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          displayName: string;
          accessLevel: ResourceAccessLevel;
          sapNumber?: string | null;
        } | null;
        queryDetails?:
          | {
              __typename: 'AbapQuery';
              id: string;
              system: string;
              objectType: string;
              objectName: string;
              objectOwner?: string | null;
              collectionPackage: string;
              collectionOwner?: string | null;
              applicationComponent: string;
              repositoryProgramType: string;
              repositoryProgramId: string;
              repositoryProgramName: string;
              translationArea: string;
              languagesTranslatorTeams?: string | null;
              maxLength?: number | null;
            }
          | {
              __typename: 'CorporateContentQuery';
              id: string;
              fileName: string;
              xtmProjectNameCC?: string | null;
            }
          | {
              __typename: 'DitaQuery';
              id: string;
              deliverable: string;
              cmsProject: string;
              fileTitle: string;
              submap?: string | null;
              loio: string;
              fileName: string;
              sourceContact: string;
              sourceContactDisplayName: string;
              languagesTranslatorTeams?: string | null;
              xtmProjectNameDita?: string | null;
            }
          | {
              __typename: 'MarketingQuery';
              id: string;
              account?: string | null;
              fileNameMkt?: string | null;
            }
          | {
              __typename: 'NonAbapQuery';
              id: string;
              xtmProjectName: string;
              repository: string;
              collection: string;
              fileName: string;
              stringId: string;
              sourceContact: string;
              sourceContactDisplayName: string;
              languagesTranslatorTeams?: string | null;
            }
          | {
              __typename: 'NotesQuery';
              id: string;
              documentNumber: string;
              component: string;
              documentType: DocumentType;
              worklist?: Worklist | null;
              documentResponsible?: string | null;
              documentResponsibleDisplayName?: string | null;
            }
          | { __typename: 'TrainingQuery'; id: string; xtmProjectName: string; fileName: string }
          | null;
      };
    }> | null;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetQueryDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
  isInternal?: Scalars['Boolean'];
}>;

export type GetQueryDetailsQuery = {
  __typename?: 'Query';
  query?: {
    __typename?: 'BaseQuery';
    id: string;
    qtId?: number | null;
    deadline: string;
    status: Status;
    sourceText?: string | null;
    targetText?: string | null;
    targetLanguage: string;
    issueType: IssueType;
    details?: string | null;
    assignee?: string | null;
    submitterGroupName?: string | null;
    translationType: TranslationType;
    createdAt: any;
    qeReview: boolean;
    forwardReviewTo?: ForwardReview | null;
    queryDetails?:
      | {
          __typename: 'AbapQuery';
          id: string;
          system: string;
          objectType: string;
          objectName: string;
          objectOwner?: string | null;
          collectionPackage: string;
          collectionOwner?: string | null;
          applicationComponent: string;
          repositoryProgramType: string;
          repositoryProgramId: string;
          repositoryProgramName: string;
          translationArea: string;
          languagesTranslatorTeams?: string | null;
          maxLength?: number | null;
        }
      | {
          __typename: 'CorporateContentQuery';
          id: string;
          fileName: string;
          xtmProjectNameCC?: string | null;
        }
      | {
          __typename: 'DitaQuery';
          id: string;
          deliverable: string;
          cmsProject: string;
          fileTitle: string;
          submap?: string | null;
          loio: string;
          fileName: string;
          sourceContact: string;
          sourceContactDisplayName: string;
          languagesTranslatorTeams?: string | null;
          xtmProjectNameDita?: string | null;
        }
      | {
          __typename: 'MarketingQuery';
          id: string;
          account?: string | null;
          fileNameMkt?: string | null;
        }
      | {
          __typename: 'NonAbapQuery';
          id: string;
          xtmProjectName: string;
          repository: string;
          collection: string;
          fileName: string;
          stringId: string;
          sourceContact: string;
          sourceContactDisplayName: string;
          languagesTranslatorTeams?: string | null;
        }
      | {
          __typename: 'NotesQuery';
          id: string;
          documentNumber: string;
          component: string;
          documentType: DocumentType;
          worklist?: Worklist | null;
          documentResponsible?: string | null;
          documentResponsibleDisplayName?: string | null;
        }
      | { __typename: 'TrainingQuery'; id: string; xtmProjectName: string; fileName: string }
      | null;
    assignedTo?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      displayName: string;
      accessLevel: ResourceAccessLevel;
      sapNumber?: string | null;
    } | null;
    project: {
      __typename?: 'Project';
      projectName: string;
      id: string;
      name: string;
      projectManager?: string | null;
      qualityExpert?: string | null;
      queryResponsible?: string | null;
      deadline?: string | null;
      stakeholders?: Array<{
        __typename?: 'ProjectStakeholder';
        id: string;
        stakeholderRole: StakeholderRole;
        userName: string;
        displayName?: string | null;
      }> | null;
      languages: Array<{
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
        supplier: string;
        deadline?: any | null;
      } | null>;
    };
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      name: string;
      createdAt: any;
      uploadedBy: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        sapNumber?: string | null;
      };
    }>;
    createdBy: {
      __typename?: 'User';
      accessLevel: ResourceAccessLevel;
      internal: boolean;
      id: string;
      firstName: string;
      lastName: string;
      displayName: string;
      sapNumber?: string | null;
    };
    comments: Array<{
      __typename?: 'QueryComment';
      id: string;
      commentText: string;
      commentType: CommentType;
      createdAt: any;
      updatedAt: any;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        displayName: string;
        accessLevel: ResourceAccessLevel;
        supplierLanguages?: {
          __typename?: 'UserSupplierLanguages';
          name: string;
          code: string;
          languages: Array<string>;
        } | null;
      };
    }>;
    distributions: Array<{
      __typename?: 'Distribution';
      id: string;
      status: DistributionStatus;
      updatedAt: any;
      distribute: boolean;
      language: {
        __typename?: 'ProjectLanguage';
        id: string;
        language: string;
        supplier: string;
        deadline?: any | null;
      };
    }>;
    languagesByQueryCreator: Array<{
      __typename?: 'ProjectLanguage';
      id: string;
      language: string;
    } | null>;
  } | null;
};

export type GetSearchFiltersQueryVariables = Exact<{ [key: string]: never }>;

export type GetSearchFiltersQuery = {
  __typename?: 'Query';
  searchFilters: Array<{
    __typename?: 'SearchFilter';
    id: string;
    name: string;
    isDefault: boolean;
    favorite: boolean;
    isSubscribed: boolean;
    filters: Array<{
      __typename?: 'SearchFilterField';
      key: string;
      value?: string | null;
      enabled: boolean;
    }>;
    columnConfig?: {
      __typename?: 'ColumnConfig';
      id?: boolean | null;
      deadline?: boolean | null;
      status?: boolean | null;
      translation?: boolean | null;
      source?: boolean | null;
      issue?: boolean | null;
      language?: boolean | null;
      xtmProjectName?: boolean | null;
      filename?: boolean | null;
      projectName?: boolean | null;
      projectManager?: boolean | null;
      qualityExpert?: boolean | null;
      qmContact?: boolean | null;
      substitutePm?: boolean | null;
      assignee?: boolean | null;
      creator?: boolean | null;
      queryCreatedAt?: boolean | null;
      submitterGroupName?: boolean | null;
      loio?: boolean | null;
      repository?: boolean | null;
      collection?: boolean | null;
      stringId?: boolean | null;
      queryTrackerId?: boolean | null;
      account?: boolean | null;
      applicationComponent?: boolean | null;
      sourceContact?: boolean | null;
    } | null;
  }>;
};

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserInfoQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    internal: boolean;
    firstName: string;
    lastName: string;
    suppliers: Array<{ __typename?: 'Supplier'; id: string; vendor: string; name: string }>;
  } | null;
};

export const AbapQueryDetailsFragmentDoc = gql`
  fragment ABAPQueryDetails on AbapQuery {
    id
    system
    objectType
    objectName
    objectOwner
    collectionPackage
    collectionOwner
    applicationComponent
    repositoryProgramType
    repositoryProgramId
    repositoryProgramName
    translationArea
    languagesTranslatorTeams
    maxLength
  }
`;
export const UserNameFragmentDoc = gql`
  fragment UserName on User {
    id
    firstName
    lastName
    displayName
    accessLevel
    sapNumber
  }
`;
export const LanguageWithSupplierFragmentDoc = gql`
  fragment LanguageWithSupplier on ProjectLanguage {
    id
    language
    supplier
    deadline @include(if: $isInternal)
  }
`;
export const ProjectWithLanguagesAndSupplierFragmentDoc = gql`
  fragment ProjectWithLanguagesAndSupplier on Project {
    id
    name
    projectManager
    qualityExpert
    queryResponsible
    deadline
    languages {
      ...LanguageWithSupplier
    }
  }
  ${LanguageWithSupplierFragmentDoc}
`;
export const ProjectStakeholderFragmentDoc = gql`
  fragment ProjectStakeholder on ProjectStakeholder {
    id
    stakeholderRole
    userName
    displayName
  }
`;
export const CommentFragmentDoc = gql`
  fragment Comment on QueryComment {
    id
    commentText
    commentType
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      displayName
      accessLevel
      supplierLanguages {
        name
        code
        languages
      }
    }
  }
`;
export const BaseQueryDetailsFragmentDoc = gql`
  fragment BaseQueryDetails on BaseQuery {
    id
    qtId
    deadline
    status
    sourceText
    targetText
    targetLanguage
    issueType
    details
    assignee
    assignedTo {
      ...UserName
    }
    submitterGroupName
    translationType
    createdAt
    qeReview
    forwardReviewTo
    project {
      ...ProjectWithLanguagesAndSupplier
      projectName
      stakeholders {
        ...ProjectStakeholder
      }
    }
    attachments {
      id
      name
      createdAt
      uploadedBy {
        ...UserName
      }
    }
    createdBy {
      accessLevel
      ...UserName
      internal
    }
    comments {
      ...Comment
    }
    distributions {
      id
      status
      updatedAt
      distribute
      language {
        ...LanguageWithSupplier
      }
    }
    languagesByQueryCreator {
      id
      language
    }
  }
  ${UserNameFragmentDoc}
  ${ProjectWithLanguagesAndSupplierFragmentDoc}
  ${ProjectStakeholderFragmentDoc}
  ${CommentFragmentDoc}
  ${LanguageWithSupplierFragmentDoc}
`;
export const CorporateContentQueryDetailsFragmentDoc = gql`
  fragment CorporateContentQueryDetails on CorporateContentQuery {
    id
    xtmProjectNameCC: xtmProjectName
    fileName
  }
`;
export const DitaQueryDetailsFragmentDoc = gql`
  fragment DitaQueryDetails on DitaQuery {
    id
    xtmProjectNameDita: xtmProjectName
    deliverable
    cmsProject
    fileTitle
    submap
    loio
    fileName
    sourceContact
    sourceContactDisplayName
    languagesTranslatorTeams
  }
`;
export const MarketingQueryDetailsFragmentDoc = gql`
  fragment MarketingQueryDetails on MarketingQuery {
    id
    account
    fileNameMkt: fileName
  }
`;
export const MsGraphUserDetailsFragmentDoc = gql`
  fragment MsGraphUserDetails on MsGraphUser {
    id
    displayName
    givenName
    surname
    mail
    userPrincipalName
    department
    sapNumber
    sapName
  }
`;
export const NonAbapQueryDetailsFragmentDoc = gql`
  fragment NonAbapQueryDetails on NonAbapQuery {
    id
    xtmProjectName
    repository
    collection
    fileName
    stringId
    sourceContact
    sourceContactDisplayName
    languagesTranslatorTeams
  }
`;
export const NotesQueryDetailsFragmentDoc = gql`
  fragment NotesQueryDetails on NotesQuery {
    id
    documentNumber
    component
    documentType
    worklist
    documentResponsible
    documentResponsibleDisplayName
  }
`;
export const ProjectFieldsFragmentDoc = gql`
  fragment ProjectFields on Project {
    id
    name
    projectManager @include(if: $isInternal)
    qualityExpert @include(if: $isInternal)
    queryResponsible @include(if: $isInternal)
    projectName
    stakeholders @include(if: $isInternal) {
      ...ProjectStakeholder
    }
  }
  ${ProjectStakeholderFragmentDoc}
`;
export const ProjectWithLanguagesFragmentDoc = gql`
  fragment ProjectWithLanguages on Project {
    id
    name
    projectManager
    qualityExpert
    queryResponsible
    languages {
      id
      language
    }
  }
`;
export const SearchFilterFieldDetailsFragmentDoc = gql`
  fragment SearchFilterFieldDetails on SearchFilterField {
    key
    value
    enabled
  }
`;
export const ColumnsFragmentDoc = gql`
  fragment Columns on ColumnConfig {
    id
    deadline
    status
    translation
    source
    issue
    language
    xtmProjectName
    filename
    projectName
    projectManager
    qualityExpert
    qmContact
    substitutePm
    assignee
    creator
    queryCreatedAt
    submitterGroupName
    loio
    repository
    collection
    stringId
    queryTrackerId
    account
    applicationComponent
    sourceContact
  }
`;
export const SearchFilterDetailsFragmentDoc = gql`
  fragment SearchFilterDetails on SearchFilter {
    id
    name
    isDefault
    favorite
    isSubscribed
    filters {
      ...SearchFilterFieldDetails
    }
    columnConfig {
      ...Columns
    }
  }
  ${SearchFilterFieldDetailsFragmentDoc}
  ${ColumnsFragmentDoc}
`;
export const SupplierDetailsFragmentDoc = gql`
  fragment SupplierDetails on Supplier {
    id
    vendor
    name
  }
`;
export const TrainingQueryDetailsFragmentDoc = gql`
  fragment TrainingQueryDetails on TrainingQuery {
    id
    xtmProjectName
    fileName
  }
`;
export const AddAnswerToQueryDocument = gql`
  mutation AddAnswerToQuery($input: QueryAnswerInput!, $isInternal: Boolean! = true) {
    query: provideAnswer(input: $input) {
      id
      status
      assignee
      comments {
        ...Comment
      }
      distributions {
        id
        status
        updatedAt
        distribute
        language {
          ...LanguageWithSupplier
        }
      }
    }
  }
  ${CommentFragmentDoc}
  ${LanguageWithSupplierFragmentDoc}
`;

export function useAddAnswerToQueryMutation() {
  return Urql.useMutation<AddAnswerToQueryMutation, AddAnswerToQueryMutationVariables>(
    AddAnswerToQueryDocument
  );
}
export const AddCommentToQueryDocument = gql`
  mutation AddCommentToQuery($input: QueryCommentInput!) {
    comment: addCommentToQuery(input: $input) {
      ...Comment
    }
  }
  ${CommentFragmentDoc}
`;

export function useAddCommentToQueryMutation() {
  return Urql.useMutation<AddCommentToQueryMutation, AddCommentToQueryMutationVariables>(
    AddCommentToQueryDocument
  );
}
export const ClarifyQueryDocument = gql`
  mutation ClarifyQuery($input: ClarifyQueryInput!) {
    query: clarifyQuery(input: $input) {
      id
      status
      comments {
        ...Comment
      }
    }
  }
  ${CommentFragmentDoc}
`;

export function useClarifyQueryMutation() {
  return Urql.useMutation<ClarifyQueryMutation, ClarifyQueryMutationVariables>(
    ClarifyQueryDocument
  );
}
export const CompleteDistributionDocument = gql`
  mutation CompleteDistribution($input: CompleteDistributionInput!) {
    distribution: completeDistribution(input: $input) {
      id
      status
      updatedAt
      query {
        id
        status
        comments {
          ...Comment
        }
      }
    }
  }
  ${CommentFragmentDoc}
`;

export function useCompleteDistributionMutation() {
  return Urql.useMutation<CompleteDistributionMutation, CompleteDistributionMutationVariables>(
    CompleteDistributionDocument
  );
}
export const CompleteAnsweredQueryDocument = gql`
  mutation CompleteAnsweredQuery($id: ID!) {
    query: completeAnsweredQuery(id: $id) {
      id
      status
      comments {
        ...Comment
      }
    }
  }
  ${CommentFragmentDoc}
`;

export function useCompleteAnsweredQueryMutation() {
  return Urql.useMutation<CompleteAnsweredQueryMutation, CompleteAnsweredQueryMutationVariables>(
    CompleteAnsweredQueryDocument
  );
}
export const CreateAbapDocument = gql`
  mutation CreateABAP($input: AbapInput!, $files: [Upload!]) {
    query: createAbapQuery(input: $input, files: $files) {
      id
    }
  }
`;

export function useCreateAbapMutation() {
  return Urql.useMutation<CreateAbapMutation, CreateAbapMutationVariables>(CreateAbapDocument);
}
export const CreateCorporateContentDocument = gql`
  mutation CreateCorporateContent($input: CorporateContentInput!, $files: [Upload!]) {
    query: createCorporateContentQuery(input: $input, files: $files) {
      id
    }
  }
`;

export function useCreateCorporateContentMutation() {
  return Urql.useMutation<CreateCorporateContentMutation, CreateCorporateContentMutationVariables>(
    CreateCorporateContentDocument
  );
}
export const CreateDitaDocument = gql`
  mutation createDita($input: DitaInput!, $files: [Upload!]) {
    query: createDitaQuery(input: $input, files: $files) {
      id
    }
  }
`;

export function useCreateDitaMutation() {
  return Urql.useMutation<CreateDitaMutation, CreateDitaMutationVariables>(CreateDitaDocument);
}
export const CreateMarketingDocument = gql`
  mutation CreateMarketing($input: MarketingInput!, $files: [Upload!]) {
    query: createMarketingQuery(input: $input, files: $files) {
      id
    }
  }
`;

export function useCreateMarketingMutation() {
  return Urql.useMutation<CreateMarketingMutation, CreateMarketingMutationVariables>(
    CreateMarketingDocument
  );
}
export const CreateNonAbapDocument = gql`
  mutation CreateNonAbap($input: NonAbapInput!, $files: [Upload!]) {
    query: createNonAbapQuery(input: $input, files: $files) {
      id
    }
  }
`;

export function useCreateNonAbapMutation() {
  return Urql.useMutation<CreateNonAbapMutation, CreateNonAbapMutationVariables>(
    CreateNonAbapDocument
  );
}
export const CreateNotesDocument = gql`
  mutation CreateNotes($input: NotesInput!, $files: [Upload!]) {
    query: createNotesQuery(input: $input, files: $files) {
      id
    }
  }
`;

export function useCreateNotesMutation() {
  return Urql.useMutation<CreateNotesMutation, CreateNotesMutationVariables>(CreateNotesDocument);
}
export const CreateSearchFilterDocument = gql`
  mutation createSearchFilter($input: SearchFilterCreate!) {
    mutation: createSearchFilter(searchFilter: $input) {
      ...SearchFilterDetails
    }
  }
  ${SearchFilterDetailsFragmentDoc}
`;

export function useCreateSearchFilterMutation() {
  return Urql.useMutation<CreateSearchFilterMutation, CreateSearchFilterMutationVariables>(
    CreateSearchFilterDocument
  );
}
export const CreateTrainingDocument = gql`
  mutation CreateTraining($input: TrainingInput!, $files: [Upload!]) {
    query: createTrainingQuery(input: $input, files: $files) {
      id
    }
  }
`;

export function useCreateTrainingMutation() {
  return Urql.useMutation<CreateTrainingMutation, CreateTrainingMutationVariables>(
    CreateTrainingDocument
  );
}
export const DeleteFileDocument = gql`
  mutation DeleteFile($id: ID!) {
    deleteFile(id: $id)
  }
`;

export function useDeleteFileMutation() {
  return Urql.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument);
}
export const DeleteQueryByIdDocument = gql`
  mutation DeleteQueryById($id: Int!) {
    deleteQueryById(id: $id)
  }
`;

export function useDeleteQueryByIdMutation() {
  return Urql.useMutation<DeleteQueryByIdMutation, DeleteQueryByIdMutationVariables>(
    DeleteQueryByIdDocument
  );
}
export const DiscontinueQueryByIdDocument = gql`
  mutation DiscontinueQueryById($id: ID!) {
    query: discontinueQueryById(id: $id) {
      id
      status
    }
  }
`;

export function useDiscontinueQueryByIdMutation() {
  return Urql.useMutation<DiscontinueQueryByIdMutation, DiscontinueQueryByIdMutationVariables>(
    DiscontinueQueryByIdDocument
  );
}
export const DistributeQueryDocument = gql`
  mutation DistributeQuery($id: ID!, $isInternal: Boolean! = true) {
    query: distributeQuery(id: $id) {
      id
      status
      comments {
        ...Comment
      }
      distributions {
        id
        status
        updatedAt
        distribute
        language {
          ...LanguageWithSupplier
        }
      }
    }
  }
  ${CommentFragmentDoc}
  ${LanguageWithSupplierFragmentDoc}
`;

export function useDistributeQueryMutation() {
  return Urql.useMutation<DistributeQueryMutation, DistributeQueryMutationVariables>(
    DistributeQueryDocument
  );
}
export const ForwardToAnswererDocument = gql`
  mutation ForwardToAnswerer($id: ID!) {
    forwardToAnswerer(id: $id) {
      id
      status
      comments {
        ...Comment
      }
    }
  }
  ${CommentFragmentDoc}
`;

export function useForwardToAnswererMutation() {
  return Urql.useMutation<ForwardToAnswererMutation, ForwardToAnswererMutationVariables>(
    ForwardToAnswererDocument
  );
}
export const ForwardToCreatorDocument = gql`
  mutation ForwardToCreator($id: ID!) {
    forwardToCreator(id: $id) {
      id
      status
      comments {
        ...Comment
      }
    }
  }
  ${CommentFragmentDoc}
`;

export function useForwardToCreatorMutation() {
  return Urql.useMutation<ForwardToCreatorMutation, ForwardToCreatorMutationVariables>(
    ForwardToCreatorDocument
  );
}
export const ImportAbapQueriesDocument = gql`
  mutation ImportAbapQueries($projects: [String!]!, $startDate: String!, $endDate: String!) {
    importAbapQueries(projects: $projects, startDate: $startDate, endDate: $endDate) {
      id
      user {
        ...UserName
      }
      status
      fileName
      details
      createdAt
      finishedAt
      updatedAt
    }
  }
  ${UserNameFragmentDoc}
`;

export function useImportAbapQueriesMutation() {
  return Urql.useMutation<ImportAbapQueriesMutation, ImportAbapQueriesMutationVariables>(
    ImportAbapQueriesDocument
  );
}
export const ImportFileDocument = gql`
  mutation ImportFile($file: Upload!) {
    importFile(file: $file) {
      id
      status
      fileName
      details
      finishedAt
      createdAt
      user {
        ...UserName
      }
    }
  }
  ${UserNameFragmentDoc}
`;

export function useImportFileMutation() {
  return Urql.useMutation<ImportFileMutation, ImportFileMutationVariables>(ImportFileDocument);
}
export const RequestClarificationDocument = gql`
  mutation RequestClarification($input: RequestClarificationInput!) {
    query: requestClarification(input: $input) {
      id
      status
      forwardReviewTo
      comments {
        ...Comment
      }
    }
  }
  ${CommentFragmentDoc}
`;

export function useRequestClarificationMutation() {
  return Urql.useMutation<RequestClarificationMutation, RequestClarificationMutationVariables>(
    RequestClarificationDocument
  );
}
export const SendEmailNotificationDocument = gql`
  mutation SendEmailNotification($email: EmailInput!) {
    result: sendEmail(email: $email)
  }
`;

export function useSendEmailNotificationMutation() {
  return Urql.useMutation<SendEmailNotificationMutation, SendEmailNotificationMutationVariables>(
    SendEmailNotificationDocument
  );
}
export const SubscribeViewsDocument = gql`
  mutation subscribeViews($searchFilters: [SearchFilterSubscribe!]!) {
    mutation: bulkUpdateSearchFiltersSubscriptions(searchFilters: $searchFilters) {
      ...SearchFilterDetails
    }
  }
  ${SearchFilterDetailsFragmentDoc}
`;

export function useSubscribeViewsMutation() {
  return Urql.useMutation<SubscribeViewsMutation, SubscribeViewsMutationVariables>(
    SubscribeViewsDocument
  );
}
export const UpdateAbapQueryDocument = gql`
  mutation UpdateABAPQuery($input: AbapInputUpdate!, $isInternal: Boolean! = true) {
    query: updateAbapQuery(input: $input) {
      ...ABAPQueryDetails
      baseQuery {
        ...BaseQueryDetails
      }
    }
  }
  ${AbapQueryDetailsFragmentDoc}
  ${BaseQueryDetailsFragmentDoc}
`;

export function useUpdateAbapQueryMutation() {
  return Urql.useMutation<UpdateAbapQueryMutation, UpdateAbapQueryMutationVariables>(
    UpdateAbapQueryDocument
  );
}
export const UpdateAssigneeDocument = gql`
  mutation updateAssignee($input: BaseQueryAssigneeInputUpdate!) {
    queries: updateAssignee(input: $input) {
      id
      assignee
      status
    }
  }
`;

export function useUpdateAssigneeMutation() {
  return Urql.useMutation<UpdateAssigneeMutation, UpdateAssigneeMutationVariables>(
    UpdateAssigneeDocument
  );
}
export const UpdateCorporateContentQueryDocument = gql`
  mutation UpdateCorporateContentQuery(
    $input: CorporateContentInputUpdate!
    $isInternal: Boolean! = true
  ) {
    query: updateCorporateContentQuery(input: $input) {
      ...CorporateContentQueryDetails
      baseQuery {
        ...BaseQueryDetails
      }
    }
  }
  ${CorporateContentQueryDetailsFragmentDoc}
  ${BaseQueryDetailsFragmentDoc}
`;

export function useUpdateCorporateContentQueryMutation() {
  return Urql.useMutation<
    UpdateCorporateContentQueryMutation,
    UpdateCorporateContentQueryMutationVariables
  >(UpdateCorporateContentQueryDocument);
}
export const UpdateDitaQueryDocument = gql`
  mutation updateDitaQuery($input: DitaInputUpdate!, $isInternal: Boolean! = true) {
    query: updateDitaQuery(input: $input) {
      ...DitaQueryDetails
      baseQuery {
        ...BaseQueryDetails
      }
    }
  }
  ${DitaQueryDetailsFragmentDoc}
  ${BaseQueryDetailsFragmentDoc}
`;

export function useUpdateDitaQueryMutation() {
  return Urql.useMutation<UpdateDitaQueryMutation, UpdateDitaQueryMutationVariables>(
    UpdateDitaQueryDocument
  );
}
export const UpdateMarketingQueryDocument = gql`
  mutation UpdateMarketingQuery($input: MarketingInputUpdate!, $isInternal: Boolean! = true) {
    query: updateMarketingQuery(input: $input) {
      ...MarketingQueryDetails
      baseQuery {
        ...BaseQueryDetails
      }
    }
  }
  ${MarketingQueryDetailsFragmentDoc}
  ${BaseQueryDetailsFragmentDoc}
`;

export function useUpdateMarketingQueryMutation() {
  return Urql.useMutation<UpdateMarketingQueryMutation, UpdateMarketingQueryMutationVariables>(
    UpdateMarketingQueryDocument
  );
}
export const UpdateNonAbapQueryDocument = gql`
  mutation updateNonAbapQuery($input: NonAbapInputUpdate!, $isInternal: Boolean! = true) {
    query: updateNonAbapQuery(input: $input) {
      ...NonAbapQueryDetails
      baseQuery {
        ...BaseQueryDetails
      }
    }
  }
  ${NonAbapQueryDetailsFragmentDoc}
  ${BaseQueryDetailsFragmentDoc}
`;

export function useUpdateNonAbapQueryMutation() {
  return Urql.useMutation<UpdateNonAbapQueryMutation, UpdateNonAbapQueryMutationVariables>(
    UpdateNonAbapQueryDocument
  );
}
export const UpdateNotesQueryDocument = gql`
  mutation UpdateNotesQuery($input: NotesInputUpdate!, $isInternal: Boolean! = true) {
    query: updateNotesQuery(input: $input) {
      ...NotesQueryDetails
      baseQuery {
        ...BaseQueryDetails
      }
    }
  }
  ${NotesQueryDetailsFragmentDoc}
  ${BaseQueryDetailsFragmentDoc}
`;

export function useUpdateNotesQueryMutation() {
  return Urql.useMutation<UpdateNotesQueryMutation, UpdateNotesQueryMutationVariables>(
    UpdateNotesQueryDocument
  );
}
export const UpdateSearchFilterDocument = gql`
  mutation updateSearchFilter($input: SearchFilterUpdate!) {
    mutation: updateSearchFilter(searchFilter: $input) {
      ...SearchFilterDetails
    }
  }
  ${SearchFilterDetailsFragmentDoc}
`;

export function useUpdateSearchFilterMutation() {
  return Urql.useMutation<UpdateSearchFilterMutation, UpdateSearchFilterMutationVariables>(
    UpdateSearchFilterDocument
  );
}
export const UpdateSearchFiltersDocument = gql`
  mutation updateSearchFilters($update: [SearchFilterUpdate!]!, $delete: [SearchFilterDelete!]!) {
    mutation: bulkUpdateSearchFilters(
      searchFiltersUpdated: $update
      searchFiltersDeleted: $delete
    ) {
      ...SearchFilterDetails
    }
  }
  ${SearchFilterDetailsFragmentDoc}
`;

export function useUpdateSearchFiltersMutation() {
  return Urql.useMutation<UpdateSearchFiltersMutation, UpdateSearchFiltersMutationVariables>(
    UpdateSearchFiltersDocument
  );
}
export const UpdateTrainingQueryDocument = gql`
  mutation updateTrainingQuery($input: TrainingInputUpdate!, $isInternal: Boolean! = true) {
    query: updateTrainingQuery(input: $input) {
      ...TrainingQueryDetails
      baseQuery {
        ...BaseQueryDetails
      }
    }
  }
  ${TrainingQueryDetailsFragmentDoc}
  ${BaseQueryDetailsFragmentDoc}
`;

export function useUpdateTrainingQueryMutation() {
  return Urql.useMutation<UpdateTrainingQueryMutation, UpdateTrainingQueryMutationVariables>(
    UpdateTrainingQueryDocument
  );
}
export const UpdateUserSupplierDocument = gql`
  mutation updateUserSupplier($input: [SupplierInput!]!, $internal: Boolean!) {
    updateUserSupplier(input: $input, internal: $internal) {
      id
      internal
      suppliers {
        ...SupplierDetails
      }
    }
  }
  ${SupplierDetailsFragmentDoc}
`;

export function useUpdateUserSupplierMutation() {
  return Urql.useMutation<UpdateUserSupplierMutation, UpdateUserSupplierMutationVariables>(
    UpdateUserSupplierDocument
  );
}
export const UploadFileDocument = gql`
  mutation UploadFile($id: ID!, $file: Upload!) {
    uploadFile(id: $id, file: $file) {
      attachment {
        id
      }
    }
  }
`;

export function useUploadFileMutation() {
  return Urql.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument);
}
export const GetAllProjectNamesDocument = gql`
  query GetAllProjectNames {
    projects: findAllProjects {
      id
      projectName
    }
  }
`;

export function useGetAllProjectNamesQuery(
  options?: Omit<Urql.UseQueryArgs<GetAllProjectNamesQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetAllProjectNamesQuery, GetAllProjectNamesQueryVariables>({
    query: GetAllProjectNamesDocument,
    ...options
  });
}
export const GetAllQueryTrackerImportsDocument = gql`
  query GetAllQueryTrackerImports {
    qtImports: findAllQTImports {
      id
      status
      fileName
      details
      finishedAt
      createdAt
      user {
        ...UserName
      }
    }
  }
  ${UserNameFragmentDoc}
`;

export function useGetAllQueryTrackerImportsQuery(
  options?: Omit<Urql.UseQueryArgs<GetAllQueryTrackerImportsQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetAllQueryTrackerImportsQuery, GetAllQueryTrackerImportsQueryVariables>({
    query: GetAllQueryTrackerImportsDocument,
    ...options
  });
}
export const GetAttachmentUrlDocument = gql`
  query GetAttachmentUrl($id: ID!) {
    attachment: getAttachmentUrl(id: $id) {
      url
    }
  }
`;

export function useGetAttachmentUrlQuery(
  options: Omit<Urql.UseQueryArgs<GetAttachmentUrlQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetAttachmentUrlQuery, GetAttachmentUrlQueryVariables>({
    query: GetAttachmentUrlDocument,
    ...options
  });
}
export const GetMsGraphUserDocument = gql`
  query getMsGraphUser {
    user: getMsGraphUser {
      ...MsGraphUserDetails
    }
  }
  ${MsGraphUserDetailsFragmentDoc}
`;

export function useGetMsGraphUserQuery(
  options?: Omit<Urql.UseQueryArgs<GetMsGraphUserQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetMsGraphUserQuery, GetMsGraphUserQueryVariables>({
    query: GetMsGraphUserDocument,
    ...options
  });
}
export const GetMsGraphUsersSearchByQueryDocument = gql`
  query getMsGraphUsersSearchByQuery($query: String!) {
    users: getMsGraphUsersSearchByQuery(query: $query) {
      ...MsGraphUserDetails
    }
  }
  ${MsGraphUserDetailsFragmentDoc}
`;

export function useGetMsGraphUsersSearchByQueryQuery(
  options: Omit<Urql.UseQueryArgs<GetMsGraphUsersSearchByQueryQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    GetMsGraphUsersSearchByQueryQuery,
    GetMsGraphUsersSearchByQueryQueryVariables
  >({ query: GetMsGraphUsersSearchByQueryDocument, ...options });
}
export const GetProjectDetailsDocument = gql`
  query GetProjectDetails($id: Int!) {
    project: findProjectById(id: $id) {
      id
      projectManager
      deadline
    }
  }
`;

export function useGetProjectDetailsQuery(
  options: Omit<Urql.UseQueryArgs<GetProjectDetailsQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetProjectDetailsQuery, GetProjectDetailsQueryVariables>({
    query: GetProjectDetailsDocument,
    ...options
  });
}
export const GetProjectsByTranslationTypeDocument = gql`
  query GetProjectsByTranslationType($translationType: TranslationType!) {
    projects: findProjectsByTranslationType(translationType: $translationType) {
      id
      name
      projectName
      projectId
      deadline
      englishDeadline
      languages {
        id
        language
      }
    }
  }
`;

export function useGetProjectsByTranslationTypeQuery(
  options: Omit<Urql.UseQueryArgs<GetProjectsByTranslationTypeQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    GetProjectsByTranslationTypeQuery,
    GetProjectsByTranslationTypeQueryVariables
  >({ query: GetProjectsByTranslationTypeDocument, ...options });
}
export const GetQtProjectImportDocument = gql`
  query GetQTProjectImport($searchTerm: String!, $startDate: String!, $endDate: String!) {
    projects: findQTProjectImport(
      searchTerm: $searchTerm
      startDate: $startDate
      endDate: $endDate
    ) {
      projectName
      numberOfQueries
    }
  }
`;

export function useGetQtProjectImportQuery(
  options: Omit<Urql.UseQueryArgs<GetQtProjectImportQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetQtProjectImportQuery, GetQtProjectImportQueryVariables>({
    query: GetQtProjectImportDocument,
    ...options
  });
}
export const GetQueriesPageDocument = gql`
  query GetQueriesPage(
    $limit: Int!
    $after: String
    $filters: BaseQueryFilters
    $isInternal: Boolean! = true
  ) {
    response: findBaseQueriesPage(limit: $limit, after: $after, filters: $filters) {
      edges {
        node {
          id
          qtId
          deadline
          status
          qeReview
          translationType
          sourceText
          issueType
          targetLanguage
          assignee @include(if: $isInternal)
          submitterGroupName
          createdAt
          project {
            ...ProjectFields
          }
          createdBy {
            ...UserName
          }
          assignedTo @include(if: $isInternal) {
            ...UserName
          }
          queryDetails {
            __typename
            ... on NonAbapQuery {
              ...NonAbapQueryDetails
            }
            ... on DitaQuery {
              ...DitaQueryDetails
            }
            ... on TrainingQuery {
              ...TrainingQueryDetails
            }
            ... on CorporateContentQuery {
              ...CorporateContentQueryDetails
            }
            ... on AbapQuery {
              ...ABAPQueryDetails
            }
            ... on NotesQuery {
              ...NotesQueryDetails
            }
            ... on MarketingQuery {
              ...MarketingQueryDetails
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      total
    }
  }
  ${ProjectFieldsFragmentDoc}
  ${UserNameFragmentDoc}
  ${NonAbapQueryDetailsFragmentDoc}
  ${DitaQueryDetailsFragmentDoc}
  ${TrainingQueryDetailsFragmentDoc}
  ${CorporateContentQueryDetailsFragmentDoc}
  ${AbapQueryDetailsFragmentDoc}
  ${NotesQueryDetailsFragmentDoc}
  ${MarketingQueryDetailsFragmentDoc}
`;

export function useGetQueriesPageQuery(
  options: Omit<Urql.UseQueryArgs<GetQueriesPageQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetQueriesPageQuery, GetQueriesPageQueryVariables>({
    query: GetQueriesPageDocument,
    ...options
  });
}
export const GetQueryDetailsDocument = gql`
  query GetQueryDetails($id: Int!, $isInternal: Boolean! = true) {
    query: findBaseQueryById(id: $id) {
      ...BaseQueryDetails
      queryDetails {
        __typename
        ... on NonAbapQuery {
          ...NonAbapQueryDetails
        }
        ... on DitaQuery {
          ...DitaQueryDetails
        }
        ... on TrainingQuery {
          ...TrainingQueryDetails
        }
        ... on CorporateContentQuery {
          ...CorporateContentQueryDetails
        }
        ... on AbapQuery {
          ...ABAPQueryDetails
        }
        ... on NotesQuery {
          ...NotesQueryDetails
        }
        ... on MarketingQuery {
          ...MarketingQueryDetails
        }
      }
    }
  }
  ${BaseQueryDetailsFragmentDoc}
  ${NonAbapQueryDetailsFragmentDoc}
  ${DitaQueryDetailsFragmentDoc}
  ${TrainingQueryDetailsFragmentDoc}
  ${CorporateContentQueryDetailsFragmentDoc}
  ${AbapQueryDetailsFragmentDoc}
  ${NotesQueryDetailsFragmentDoc}
  ${MarketingQueryDetailsFragmentDoc}
`;

export function useGetQueryDetailsQuery(
  options: Omit<Urql.UseQueryArgs<GetQueryDetailsQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetQueryDetailsQuery, GetQueryDetailsQueryVariables>({
    query: GetQueryDetailsDocument,
    ...options
  });
}
export const GetSearchFiltersDocument = gql`
  query GetSearchFilters {
    searchFilters: findSearchFilters {
      ...SearchFilterDetails
    }
  }
  ${SearchFilterDetailsFragmentDoc}
`;

export function useGetSearchFiltersQuery(
  options?: Omit<Urql.UseQueryArgs<GetSearchFiltersQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>({
    query: GetSearchFiltersDocument,
    ...options
  });
}
export const GetUserInfoDocument = gql`
  query GetUserInfo {
    user: getUserInfo {
      id
      internal
      firstName
      lastName
      suppliers {
        ...SupplierDetails
      }
    }
  }
  ${SupplierDetailsFragmentDoc}
`;

export function useGetUserInfoQuery(
  options?: Omit<Urql.UseQueryArgs<GetUserInfoQueryVariables>, 'query'>
) {
  return Urql.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>({
    query: GetUserInfoDocument,
    ...options
  });
}
